/* eslint-disable */
// Auto-generated by scripts/build-pan-xiangyi-lookup.mjs
// Source: /Users/xiaodongliu/Downloads/轩书房/4-成果/备课/国学备课/奇门象意速记/拆分象意
// Do not edit manually.

export const PAN_SYMBOL_DETAIL_LOOKUP = {
  "door:杜": [
    "核心原点 ①：堵塞 → 隔绝、关闭与隐藏",
    "概念： 阻塞、阻止、困难、限制、闭塞、隐藏、覆盖、遮掩、关闭、断绝、抑郁。",
    "人物： 聋哑人、中风者。",
    "形态： 晦涩、呆滞、深色安然。",
    "人体： 呼吸系统、肝、胆、筋、血栓、循环系统不畅或被堵塞的部位。",
    "动物： 夜行动物（在黑暗中隐藏），如：黄鼠狼、老鼠、猫、狗、猫头鹰、蚊子。",
    "植物： 遮盖地皮的小草、庄稼、树木、苔藓植物。",
    "静物： 私房钱、门窗、瓶塞、瓶盖、衣物、被子、窗帘、内衣、胸罩。",
    "地理： 保护隐私的堤坝、围墙、隔离带、绿篱、通道、闸口、门槛、拥挤才会堵的闭塞之地、交通拥堵之地。",
    "方位/天时/色彩： 东南方；风、空气、气流、气旋；绿色。",
    "核心原点 ②：想象 → 意识、感觉与虚幻",
    "概念： 体会到的、感觉到的、意识到的、想象到的、幻觉、虚幻、推测、vr。",
    "性情： 多疑、不爱言语、心平气和、文静内向。",
    "人体： 大脑、神经。",
    "核心原点 ③：技术 → 保密、心法与艺技",
    "概念： 技术、艺技、专业技能、心法、质量（购物看）。",
    "人物： 技术人员、理论工作者、心理学者、管理学者、佛教徒、基督徒、从事神的工作、气功师、僧道、公检法、安全保密人员、狱警、军人。",
    "静物： 书籍、报刊、电子芯片。"
  ],
  "door:惊": [
    "核心原点 ①：惊恐 → 刺激、不安与怪异",
    "概念： 有惊无险、惊恐、奇怪、刺激、吃惊、诧异、惊慌、恐慌、忧疑。",
    "人物： 心律不齐之人、哮喘之人。",
    "形态： 瞠目结舌状、大眼睛、嘴闭不上、呆若木鸡状。",
    "性情： 惊恐不安、担惊受怕、忐忑不安、心事重重、心惊肉跳。",
    "人体： 心脏。",
    "天时： 雷电。",
    "核心原点 ②：发声 → 鸣叫、音乐与响声",
    "概念： 声音、音乐、响声。",
    "人物： 歌星。",
    "性情： 声音宏亮。",
    "人体： 喉咙、声带、肺、肠。",
    "动物： 蝉、蛙、蝈蝈、蟋蟀、黄鹂、麻雀、等一切善于鸣叫的生物。",
    "植物： 白杨（沙沙）、松树（松涛阵阵）。",
    "静物： 风铃、钟、音响、电视、电话、钟表、乐器、鞭炮、一切能发声的物体。",
    "地理： 闹市、汽车噪声的街道、歌厅、影院、娱乐场所、球场、草场、乐器厂、兵工厂、炸药厂、一切能够发声的场所。",
    "方位/色彩： 西；白色。",
    "核心原点 ③：口舌是非 → 辩论、官司与言辞",
    "概念： 官非、口舌是非、抖讼。",
    "人物： 律师、教师、纪检监察人员。",
    "性情： 能说会道。",
    "静物： 残缺不全带口。",
    "地理： 公安局、检察院、法院。"
  ],
  "door:景": [
    "核心原点 ①：属火 → 光明、热烈与炎症",
    "概念： 火光、流血。",
    "人物： 烫伤者、烧伤者。",
    "性情： 脾气急躁。",
    "人体： 血液、心脏、小肠。",
    "静物： 灯光、烟火爆竹、霓虹灯。",
    "地理： 电视制作发射中心。",
    "方位/天时/色彩： 南方；太阳、晴天、炎热、中午；红色、赤色。",
    "核心原点 ②：风景 → 漂亮、艺术与景象",
    "概念： 漂亮、风景、旅游、远景、前程。",
    "人物： 漂亮的人、美容美发师、美容者、旅游者、营销人、广告人、策划人、影视行业人、。",
    "形态： 漂亮、红脸、脸尖形、身体偏瘦。",
    "动物： 雉鸡、孔雀、雄鹰、鸟类、观赏鱼、观赏动物等一切漂亮的生物。",
    "植物： 漂亮的花卉、植物、盆景。",
    "静物： 图画、照片、图片、艺术品、首饰、时装、颜料、油漆、美容美发用品、书画用品、电影机、电视机、投影机、海报。",
    "地理： 旅游景区、公园、繁华街道、电影院、戏院、各厅、美容院、娱乐场所、酒吧、歌厅。",
    "核心原点 ③：文书 → 文化、信息与契约",
    "概念： 文化、文书、。",
    "人物： 文化人、作家、文学家、诗人、电信类工作者、电子产品生产经营者、信息行业人、文秘、图书管理等。",
    "性情： 心直口快、虚心处事、知书达理。",
    "静物： 图书、文件、合同、证书、书籍。"
  ],
  "door:开": [
    "核心原点 ①：打开 → 启动、行动与开启",
    "概念： 手术（打开身体）、打开、学业（开启智慧）、婚嫁（开启新的人生）、驾驶（启动车辆）。",
    "人物： 外科医生、司机。",
    "核心原点 ②：开业 → 事业开创与功成",
    "概念： 经营、经济、升迁、贸易、开创、开始、庆典、谋求。",
    "人物： 领导、公务员、白领、名人、公司企业老板、文官、创业者、生意人。",
    "地理： 工作单位、店铺、门市、办公室。",
    "核心原点 ③：开放 → 通达舒展与开朗",
    "概念： 舒展、宽广、开放、开明、开朗、顺利、通畅、出行。",
    "性情： 豁达爽朗、谈吐不凡、坦诚无私、性情愉快、无所拘束、意志活跃、思想开放、通情达理、容易沟通、讲情重义、自尊心强、勤奋好学。",
    "地理： 高亢之地、开阔之地、飞机场、车站、码头。",
    "植物： 舒展的植物。",
    "天时： 晴空万里、天高云淡。",
    "核心原点 ④：公开 → 官方显露与权威",
    "概念： 公开、暴露。",
    "人物： 法官、检察官。",
    "地理： 法院、检察院、审判庭、名人居所、公司的大门。",
    "核心原点 ⑤：金 → 乾金之象与价值",
    "五行： 金。",
    "概念：婚嫁。",
    "方位： 西北。",
    "色彩： 白色、金色。",
    "天时： 傍晚、秋天。",
    "人体： 头、肺、大肠、脊椎、骨骼。",
    "动物： 高贵华丽的动物（如虎、狮、豹、马、天鹅、龙）。",
    "植物： 高大之树、结果实的植物。",
    "静物： 金银饰品、贵重物品、圆形物品。",
    "地理： 高大建筑物、矿场。"
  ],
  "door:伤": [
    "核心原点 ①：竞争索取 → 抓捕、赌博与对抗",
    "概念：抓捕、索取、赌博、打架、对抗、挑逗、渔猎、掠夺、讨债、竞争力。",
    "人物：公安、军警、格斗者、斗殴者、讨债人、竞争对手。",
    "动物：狮子、老虎、狗、鹰、豹子（主动攻击的猛兽）。",
    "地理：公安局、检察院、法院、兵工厂。",
    "核心原点 ②：损害消耗 → 伤痛、武器与破败",
    "概念：损害、消耗、妨碍、受伤、伤心、伤痛、破败、开刀、刻薄。",
    "人物：手术医生、伤心人、受伤者、遭遇事故者。",
    "形态：恐惧、难看、丑陋、带伤痕。",
    "人体：脚、手、肝、胆、筋、眼、伤疤、术后部位。",
    "动物：蚊子、跳蚤、马蜂（刺伤、骚扰）。",
    "植物：仙人掌、刺梅、荆棘、玫瑰、月季、茅草（带刺）。",
    "静物：刀、剑、剪子、针、枪、炮、子弹、弓箭、锐器、炸药、武器、毒药、毒气；破裂不完整之物。",
    "地理：破坏的道路、悬崖、屠宰厂、医院、化工厂、危险品存放地。",
    "核心原点 ③：冲动 → 刚直、迅猛与暴烈",
    "概念：冲动、雷厉风行、刚直、不拐弯、爆发、急躁。",
    "人物：驾驶员、行动派、冲锋者。",
    "形态：威严健壮、长方脸、少笑、气势压人。",
    "性情：直爽易怒、暴躁粗野、说话做事快且硬。",
    "静物：汽车（速度与冲击力的象意）。",
    "方位/天时/色彩：东方；春天、早晨、风、雷电；青色、绿色。"
  ],
  "door:生": [
    "核心原点 ①：生活 → 根基、环境与所需",
    "概念：生活、生存、根基、依靠、靠山、衣食住行所需。",
    "静物：日常必需品、粮食、器具、生活用品。",
    "地理：住宅（阳宅风水关乎赚钱）、客厅、房屋、桥梁、街道、公园、居住社区。",
    "方位/天时/色彩：东北；云、雾、阴天；黄色。",
    "核心原点 ②：生长 → 生命、活力与延续",
    "概念：延续、生机、生长、发展、孕育、活着。",
    "人物：学生（知识在生长）、孕妇（生命在生长）、培育者、照料者。",
    "形态：方脸、厚唇、鼻子方直，神态乐观向上。",
    "性情：忠厚守时、诚恳稳重、乐观踏实。",
    "人体：鼻、嘴、胃、脾、肠（与营养生长相关）。",
    "动物/植物：泛指一切动物；泛指一切植物。",
    "核心原点 ③：生产 → 工作、经营与利润",
    "概念：工作、学习、经商、生意、生产、效益、利润、利息（投资要看）。",
    "人物：劳动者、生意人、金融机构从业者、经理人、管理者、领导者。",
    "性情：有经济头脑、务实能干、重结果。",
    "地理：工厂、农场、渔场；商店、销售部、交易市场。"
  ],
  "door:死": [
    "核心原点 ①：死亡 → 终结、病灶与凶器",
    "概念： 丧失生命、没有生命、断了念头。",
    "人物： 故去的人、行刑之人、屠夫、救死扶伤的人。",
    "人体： 没有活力的部位、病灶部位、死疤、死肉、癌症、肿块、肿瘤。",
    "动物： 动物的尸体。",
    "植物： 有病的植物、干枯的植物。",
    "静物： 凶器（刀、枪、剑、炸弹）、绳索、枷锁、医疗器械、墓碑。",
    "地理： 地皮、坟墓、屠宰厂、不住人的空房、停尸间、医院、刑场。",
    "核心原点 ②：神佛 → 祭祀、偶像与鬼神",
    "概念： 鬼神。",
    "静物： 雕塑、神佛、偶像、木偶、手办、玩具、死人照片、俑。",
    "地理： 玩具厂、雕塑厂。",
    "核心原点 ③：死板 → 固执、僵化与不变",
    "概念： 固定资产、执着、不灵活、没有变化、不可调和、固定不变、不可周转。",
    "人物： 执着的人、不灵活的人、死板的人、不能变通的人、固执的人、无药可救的人。",
    "形态： 脸色呆板、木纳、不灵活、死板。",
    "性情： 固执迟钝、稳重保守、死心眼、死气沉沉、死不认账、一条路走到黑、不灵活。",
    "动物： 牛、羊（性情固执）、装死、冬眠、生长缓慢的动物。",
    "植物： 松树、柏树等生长缓慢的树。",
    "静物： 锁。",
    "方位/天时/色彩：西南；云、雾、雨；灰色、黑色、蓝色。"
  ],
  "door:休": [
    "核心原点 ①：休止 → 静止、终结与倦怠",
    "概念：停止、终结、死亡、倦怠、无活力、懒散（无关好坏）。",
    "人物：懒散之人、睡觉者、离退休者、死人。",
    "性情：慢、无精打采、不慌不忙、缺乏动力。",
    "形态：半睁眼、动作迟缓、姿态松垮。",
    "核心原点 ②：休闲 → 调理、放松与安逸",
    "概念：休养生息、休闲、放松、调理、整理、美容、美发、修理。",
    "人物：品质高贵之人（安然不争）、美容美发师、修理工、营养师、护士、护理人员、清闲之人、白领。",
    "形态：气质好、语音偏低、语速偏慢、着装宽松休闲。",
    "性情：温顺安然、漫不经心、随和不争。",
    "地理：广场、公园、酒吧、娱乐厅、ktv、名人居所、卧室、床、客厅、疗养院。",
    "天时：星期天、节假日。",
    "核心原点 ③：属水 → 液体、松软与温顺",
    "静物：饮料、酒、油、盐、酱油、醋、调料、水、油器、汽油、煤油、柴油、润滑油；布匹、绳索、衣物、棉花海绵。",
    "动物：金鱼、毛虫、蜗牛、水牛、黄牛（温顺、动作缓慢）。",
    "植物：水草、白菜、青菜、萝卜、芹菜、黄瓜、西瓜（含水量大）。",
    "人体：生殖系统、泌尿系统、循环系统（体液系统）。",
    "方位/色彩/天时：北方；蓝色、黑色；冬天。",
    "核心原点 ④：流动 → 旅游、运输与载具",
    "概念：旅游、运输、移动、行走、过渡、流转。",
    "静物：船、汽车、火车、自行车、电瓶车、摩托车；钟表、风扇、洗衣机、空调（内部流动）。",
    "地理：水池、水景、河流、海滨、车站、码头。",
    "天时：雨天。"
  ],
  "god:地": [
    "核心原点 ①：稳定 → 厚重、包容与持久",
    "《奇门法窍》称其为 \"坚固之神\"，大地厚德载物，兼顾稳定。",
    "概念：稳定、厚重、柔顺、文静、恭敬、谦卑、博大、包容、关怀。",
    "人物：乡农、医生、老妇人、道姑、村姑、性格柔顺的人。",
    "形态：大腹、肥厚、方脸多肉、肥胖、身材五短、声音如瓮。",
    "性情：柔顺文静。",
    "人体：胃、脾、肉、鼻、唇、腹、臀。",
    "动物：牛、猪、熊猫、大象等动作缓慢、性情温柔的动物。",
    "植物：地瓜、土豆、农作物、地衣、苔藓、地丁、姜、荸荠、大蒜、中草药。",
    "静物：五谷、布帛、沙石、缸、瓦盆、瓦罐、土制品、载物载人的车子。",
    "地理：地基、低洼地带、地下水。",
    "天时：多云、阴天（天气变化不大，相对稳定）。",
    "核心原点 ②：消极与吝啬 → 固守、缓慢与潜藏",
    "（地里的东西——老旧的东西，有消极、发展缓慢，并倾向于对内固守吝啬和对外潜藏。）",
    "概念：矮小、消极、哭泣、模糊、缓慢、困惑、吝啬、自私、旧物。",
    "人物：狱警（工作于压抑环境）、地下工作者、不公开的职业、慢吞吞的人、吝啬之人、自私消极的人。",
    "性情：自私消极、缺乏上进心、吝啬节俭。",
    "动物：地蚕、虫类（行动缓慢，生活于地下）。",
    "静物：储存粮食的器皿、储存衣物的柜子、首饰盒（核心意象为“藏”和“存”）。",
    "地理：地窖、地下室、地道、地下铁、地摊、地炉、地炕（一切与地下、潜藏相关的场所）。"
  ],
  "god:符": [
    "核心原点 ①：最有权 → 权势、领导与核心掌控",
    "《说文解字》“符，信也。”本义是古代朝廷传达命令或征调兵将的凭证。值符二字组合，象征 \"执掌凭证之人\" 或 \"持有兵符的统帅\"。",
    "《史记・淮阴侯列传》“晨自称汉使，驰入赵壁。张耳、韩信未起，即其卧内上夺其印符，以麾召诸将，易置之。”",
    "概念：重点的、有影响力的、服众的、威严的、德高望重的、有组织能力的。",
    "人物：领袖、领导、管理者、负责人、老板。",
    "人体：头（身体的最高决策与指挥中心）、手（掌控与执行权）。",
    "静物：国旗、帽徽、领徽、委任状、证书、印章、玉玺、符。",
    "地理：首都、首府、中央地带。",
    "性情：气概雄伟、文韬武略、态度安然（领导者所具备的沉稳与魄力）。",
    "核心原点 ②：最有名 → 声望、名誉与社会地位",
    "《遁甲符应经》载：\"值符者，天乙之贵神，统摄八极\"。《奇门法窍》云：\"值符天乙之神\"，是八神之首。直符是最吉神。",
    "概念：名牌的、高尚的（这些特质常与名声和地位相伴）。",
    "人物：名人、明星、教授、宗教领袖（社会上广为人知并受尊敬的人物）。",
    "人体：面（代表一个人的形象和尊严）。",
    "性情：品质高雅、庄严矍铄。",
    "色彩：绚烂、五彩缤纷（引人注目，与名气带来的光环效应相关）。",
    "核心原点 ③：最有钱 → 财富、价值与稀有珍藏",
    "概念：高贵的、高档的、稀有的。",
    "动物：名贵稀有的动物（如藏獒、老虎、熊猫、狮子、天鹅、金龙鱼、燕鱼）。",
    "植物：名贵稀有的树种和花木（如金丝楠木、红木、君子兰、玫瑰花）。",
    "静物：贵重高档物品、钱币、珠宝首饰、名贵古董、钻石、名人字画、名贵艺术品、高档家具（一切具有极高价值的物质财富）。",
    "地理：庙宇（高贵）、高档场所、首饰店、古董行（交易贵重物品的场所）、金矿、珠宝、煤矿、油矿、古建筑。"
  ],
  "god:合": [
    "核心原点 ①：多 → 众多、聚集与群体",
    "（六合指上下和四方，代表多/古代六就是多，是虚指。）",
    "概念：众多、聚集、重叠。",
    "人体：手、手指、脚趾、毛发、眉毛（皆为复数、成簇存在的身体部分）。",
    "动物：兔子、鸳鸯、狼、麻雀、蜻蜓、蝴蝶、蜜蜂、蝗虫、燕子、大雁、天鹅（一切群居双聚的动物）。",
    "植物：小树、花草、果树、竹林、柳树（常常是成片、成林生长）。",
    "地理：草地、公园、竹林、苇塘、葱岭、树林（众多植物的聚集地）。",
    "色彩：多种颜色的组合。",
    "核心原点 ②：合作 → 联合、交易与婚姻",
    "（“合”的本义就是聚合与匹配，《说文解字》\"合\"：从亼（集）从口，会意字，表示上下唇相合，引申为会合、聚合）",
    "概念：合作、联合（强强联合）、交易、谈判、结婚、共同、适合、相聚、联合、吻合、适合、共同。",
    "人物：中介人（促成合作）、组织能力强的人（能聚集众人）、艺人（需要团队合作）。",
    "静物：结婚证书、合约、合同、证书、信印、书契。",
    "核心原点 ③：和气 → 仁慈、祥和与包容",
    "（由“合作”的良好结果引申，代表一种欢乐、平和、与人为善的氛围与品格。）",
    "概念：欢乐、祥和、仁慈、包容、平和。",
    "人物：乐善好施之人、医生（带来平和安康）、人缘好的人、教师、僧道、基督徒、信教人、儿童、幼儿（角色本身多代表祥和、仁慈或天真）。",
    "形态：圆脸、兔牙、一团和气、笑容可掬、点头哈腰、缩头耸肩（皆为谦和、不具攻击性的姿态）、长相年轻。",
    "性情：开朗和平、仁慈谦让、荐贤不妒、喜做说合之事。",
    "方位/天时/色彩：东方；风和、旭日、春天、早晨；绿色。",
    "其他：人群聚集、社交活动（与和气、包容相关的群体现象）。",
    "核心原点 ④：盒子 → 收拢、关闭与容器",
    "（这是“聚合”的物理形态隐喻，代表一切具有收纳、包裹、容纳功能的事物，如同一个“盒子”。）",
    "概念：收拢、关闭、合抱。",
    "静物：合子、伞、低矮的柜子、箱子、椅子、床、窗（框状结构，有开合之能）、果品（常被装在盒/篮里）、羽毛、布帛、衣囊（用于包裹、容纳）、轿车、轮船、飞机（容纳人或物的移动容器）、钱财（常被收纳在容器里）。"
  ],
  "god:虎": [
    "核心原点 ①：凶 → 斗争、伤灾与死亡",
    "（由“虎”的凶猛本性引申，代表一切具有攻击性、破坏性、导致斗争与伤亡的人事物。《奇门法窍》称其为 \"凶暴之神\"。《史记・天官书》将白虎列为四象之一。",
    "白虎主兵戈，为战神，所以做虎符，白虎账。林冲带刀进入 “白虎节堂”；杨七郎被称为 “白虎星转世”，虽武艺高强，但结局惨烈）",
    "概念：凶猛、威严、斗争、刚毅、冷酷、强硬、官司、伤灾、牢狱、疾病、死亡。",
    "人物：好斗之人、黑社会之人、罪犯、重病人、凶杀人、孝服人、恐怖人、死亡者、屠夫。",
    "性情：凶猛刚毅、大义凛然、残暴易怒、决断冲突。",
    "人体：骨骼（身体最坚硬的部分）、拳头。",
    "动物：虎、豹、豺、狼、猎狗、鹰、食肉动物。",
    "植物：猪笼草、蒺藜草、蝎子草、荆棘、枣树、杜梨树、刺槐（一切带刺或能致伤的植物）。",
    "静物：毒品、刀剑、枪枝、武器、凶器。",
    "天时：闪电、霹雳、狂风、龙卷风、飓风、地震、火山喷发。",
    "核心原点 ②：阻隔 → 道路、关卡与屏障",
    "概念：阻隔、道路。",
    "地理：道路、关卡、收费站、悬崖、峭壁、房角、堤坝、闸口、路口。",
    "静物：锁、碾子、磨、石狮子（常立于门口形成关卡）、瓦、石、网罗、交通信号灯（道路上的规则性阻隔）。",
    "核心原点 ③：技艺 → 权力、技术与刚强",
    "概念：权力、严肃、艳丽（极致的威严和力量感）、技术过硬。",
    "人物：技术过硬之人、威猛之人、权力之人、讲义气之人（依靠刚毅的原则行事）、高科技人员、公安、军警、捕盗人、侍卫、军人、工匠。",
    "形态：圆眼、虎头虎脑、面部表情严肃或死板、身体多肌肉、强健。",
    "人体：肺、大肠（五行属金）。",
    "静物：金银、石制品、铁质品、钛制品（坚硬、需技术加工的材料）。"
  ],
  "god:蛇": [
    "核心原点 ①：变化 → 惊恐、虚幻与反复无常",
    "概念：惊恐、虚惊、怪异、虚幻、梦境、变来变去、反反复复、虚诈、虚伪、华而不实、闪烁不定、光怪陆离、灯红酒绿、耀眼、妖艳、猜疑、变化、拐弯抹角。事情走势起伏不定、说好了又有变化。",
    "人物：委屈婉转、善变之人、虚诈之人、变化无常之人、漂亮妖艳之人、做梦人、精神病患者（心智或行为不稳定）。",
    "性情：虚伪巧诈、惊恐不安、心口不一（言行不一）。",
    "人体：梦、精神（与虚幻、心智相关）。",
    "静物：灯、霓虹灯、烟火（闪烁、耀眼、光怪陆离）、带花纹的布和衣服（花纹变化多端，或有迷惑性）。",
    "地理：反光的建筑物、耀眼的光（视觉上的变幻）。",
    "天时：太阳、星星（闪烁、光芒）。",
    "核心原点 ②：缠绕 → 纠缠、弯曲与连接",
    "概念：缠绕、纠缠。（克直符，领导最怕人缠着）",
    "形态：水蛇腰、驼背（弯曲的体态）。",
    "人体：血管、神经、经络（身体内弯曲、连接的通道）。",
    "动物：蛇、蟒、蚯蚓、爬虫类、海参、海肠、地蚕、蜈蚣（长条形、爬行或蠕动的动物）。",
    "植物：龙抓槐、爬山虎、西瓜秧、南瓜秧、黄瓜秧、豆角秧、牵牛、红薯秧、藤萝、紫藤等一切蔓状类植物（缠绕、攀爬的植物）。",
    "静物：绳子、绳索、锁链、渔网（缠绕、束缚）、烟囱、汽车排气筒（细长、弯曲）、腰带、鞋带、领带、项链、手链、表链、拉锁、发辫（细长、缠绕或连接的物品）。",
    "地理：弯路、海岸线、河流、山脉、弯曲的建筑物（地理上的弯曲与连接）。",
    "核心原点 ③：狠毒 → 狡猾与恶意",
    "概念：狠毒。",
    "人物：狡猾之人、口舌毒辣之人、呻吟之人、疑心之人（具有负面心性或表现出痛苦、不安的人）。",
    "性情：奸佞心毒。",
    "人体：心脏、血液（可引申为心惊肉跳、血液中毒或情绪剧烈波动）。",
    "地理：窑燥（环境燥热、令人不安）。"
  ],
  "god:天": [
    "核心原点 ①：高 → 高远、开阔与动态",
    "（ 《奇门法窍》称其为 \"威悍之神\"，此逻辑源于“天”最直观的物理特征——高。由此引申出一切与高处、开阔、远大、以及天空中的动态相关的事物。）",
    "概念：高大、天空、虚无、高处、极端、豪放。",
    "形态：高大、魁梧。",
    "人体：头、额头（人体的最高处）。",
    "动物：飞鸟、天鹅（高空飞行的动物）。",
    "植物：高大的树、高粱、高山或高原植物。",
    "静物：高耸、帽子、眼镜、天马、直升飞机。",
    "地理：天井、天车、开阔地、高原、高空、高大建筑、楼房最高层。",
    "天时：蓝天、雷电（天空的景象）、秋天（天高气爽）。",
    "核心原点 ②：贵 → 珍贵、美丽与光明",
    "（此逻辑源于“天”的引申价值。天空给予光明，孕育珍宝，因此“九天”也代表一切贵重、美好、光明、有极高价值的事物。）",
    "概念：光明、恩赐、幸福、美丽。",
    "动物：龙（神话中最高贵的神兽）。",
    "静物：金玉、宝石、钱、镜子、铜铁、水果（自然的珍贵馈赠）、光亮玲珑物。",
    "地理：豪华地方。",
    "色彩：白色、青色（纯净、高贵的颜色）。",
    "核心原点 ③：乾 (Qián) → 权威、主宰与意志",
    "（ 《御定奇门宝鉴》云：\"九天者，乾金也，主健、主威、主扬、主显。\"此逻辑源于九天的核心卦象“乾”，代表天、君王、父亲。它象征着至高无上的权威、领导力，以及远大的意志和理想。）",
    "概念：重要、主宰、意志、灵魂、聪明。",
    "人物：领导、首脑、长辈、父辈、长官、僧道、神甫、牧师、有威望之人。",
    "形态：威严、脸方正、手绵软、言语掷地有声。",
    "性情：不怒而威、高强好动、志向远大、有时好高骛远、不切实际。",
    "动物：马（龙马精神）、虎、狮（百兽之王，权威象征）。",
    "静物：剑戟、刀枪（权力的工具）。",
    "地理：首府、办公室、经理室（权力的场所）。"
  ],
  "god:玄": [
    "核心原点 ①：欺骗 → 智慧、谎言与诡计",
    "（《奇门法窍》中称玄武为 \"盗跖之神\"由“玄”的不可捉摸引申为智慧的两面性：正面是“智巧”，负面是“诡诈”。）",
    "概念：领悟、理解、智慧、偷盗、偷情、谎言、阴谋、诡计。",
    "人物：聪明多智者、能言善辩者、文艺人才、诚信不高者、爱说谎话者、虚伪不实者、巧辩反复者、小偷、导演、演员、盗贼、娼妇。",
    "形态：贼眉鼠眼、神色不定、弯腰驼背。",
    "性情：机智灵活、巧言善辩、干练虚伪、偷奸取巧。",
    "动物：老鼠、鹰、蛇、猫头鹰（被赋予机警、狡猾或神秘的文化形象）。",
    "植物：水草、海带、紫菜、蔬菜、水果、含水量大的植物。",
    "静物：盐、酱、醋、油、酒、油漆、伞、碳、一切流体类物质；瓶、罐、瓢、缸等容器。",
    "地理：阴沟、地井、下水道、地窖、地下室、低洼地、河流、池塘、湖泊、污水、粪便、厕所、洗手间、厨房。",
    "核心原点 ②：玄虚 → 深奥、幻想与眩晕",
    "（这是“玄”的本意，代表一切幽深、神秘、模糊不清、令人困惑的事物。 \"玄\"：《说文解字》：\"幽远也。黑而有赤色者为玄。象幽而入覆之也。\"）",
    "概念：深奥、玄虚、眩晕、不可靠、不可捉摸、玄妙、神秘、幻想、神秘学、心理学、宗教、法术。",
    "人物：文士、醉客、孕妇、胎儿。",
    "形态：肩窄腿细、视力衰退。",
    "静物：图片、图画、文章、印信（承载着抽象信息，其内涵玄妙）。",
    "地理：不见光的场所、牢狱。",
    "天时：阴天、黑天。",
    "色彩：黑色、玄色。",
    "核心原点 ③：水性 → 液体、阴暗与滋润",
    "（此逻辑源于其五行“水”的根本属性，代表一切与水、液体、阴湿环境相关的人事物。）",
    "人物：水产经营者。",
    "人体：眼睛、头发（皆属肾水所主）、肾、膀胱、尿液、体液。",
    "动物：鱼类、喜水动物。"
  ],
  "god:阴": [
    "核心原点 ①：护佑 → 嘉奖、喜庆与精神庇护",
    "（太阴作为月神，为印绶，《奇门法窍》称其为 \"阴祐之神\"。印：《说文》 “执政所持信也”。官员上任必授印绶，“居官则配之，罢官则解之”。故事：战国，节印，苏秦；刘邦夺符印；秦王子婴 “素车白马献印绶”。）",
    "核心概念：护佑、贞详、喜庆、升官。",
    "人物：歌手（喜庆、艺术）、祷告者（寻求或提供庇护/祝福）、助人为乐者。",
    "性情：品质优良、正直慷慨、深谋远虑。",
    "静物：金银、羽毛、喜庆用品、玩具、镜子。",
    "地理：佛寺（精神庇护之地）。",
    "核心原点 ②：细密 → 精雕琢与缜密策划",
    "（太阴作为阴柔之气，引申为一切需要精细、缜密、巧用心思的技艺与谋划。）",
    "概念：缜密、策划、雕刻、书写、复杂花纹。",
    "人物：雕刻师、裁缝、策划师、书画家、秘书、文人（皆为心思缜密、依靠细腻技艺之人）。",
    "静物：雕琢品、字迹、墨迹、字画、化妆品（需精细涂抹）、车（内部结构精密复杂）、碾碎机（将物体变细密）、镜子。",
    "核心原点 ③：阴私 → 隐藏、遮盖与私密之地",
    "（太阴为阴暗隐私，引申为一切隐蔽、暗藏、私密的人事物，多与女性和夜晚相关。）",
    "概念：隐避、藏匿、隐私、私通、遮盖、暗处。",
    "人物：女友、二奶、私通者、女人、少女、暗中行事者、隐居者。",
    "形态：脸色白净、口似樱桃、鼻子挺直、身白如玉、四指如葱（多形容女性或文人阴柔、细腻之美）。",
    "人体：嘴（可说私密话）、肺（藏于胸腔）、皮肤（身体的遮盖）、私处、胎儿（藏于母腹）。",
    "地理：山的阴面、看不见光的房屋、地下室、潮湿的地方、洞穴、厕所、洗手间（阴暗、私密或潮湿之地）。",
    "核心原点 ④：阴谋 → 诅咒、欺诈与暗中伤害",
    "（这是“阴私”的负面延伸，代表利用隐秘达成的负面策划，如诡计、口舌是非与精神攻击。）",
    "概念：密谋、诅咒、阴谋诡计哭泣、忧疑、欺诈、口舌、淫乱。",
    "人物：巫师、哭泣者。",
    "性情：阴匿暗昧。",
    "人体：涕液（哭泣、忧伤的产物）。",
    "动物：刺猬、老鼠、猫、猫头鹰（夜间出没、行动隐秘的动物）。",
    "静物：冰、冷饮（“阴”冷之物）。"
  ],
  "star:冲": [
    "核心原点 ①：冲 → 冲动、冲击与速度",
    "《烟波钓叟歌》云：“冲任小吉未全亨。”又曰：“天冲雷神，虽主惊恐，亦助威势。利于出师征伐，报仇雪耻。”",
    "概念：冲动、直往前闯、冲击、猛烈、矛盾。",
    "人物：雷公、武士、警察、军人、报复者、证人、挑起事端者、田径运动员、武术爱好者。",
    "性情：性子急、工作麻利、为人爽快、敢打敢冲、好出风头、不稳重、好冲动、做事多为欠思考、雷厉风行。",
    "动物：天上飞的，会蹦的兔子、天鹅、燕子、鹰鹫、跳蚤、蟋蟀、蝗虫、蚱蜢。",
    "静物：乐器、音响、钟、铃、枪炮、剑、汽车、飞机、弹药、鞭炮。",
    "地理：交通枢纽、交通要道、机场、车站、公安局、派出所、噪音大的场所。",
    "天时：雷电、冰雹、海啸、地震、风。",
    "核心原点 ②：直木 → 挺拔、高大与新生",
    "形态：直、高、长方脸、长发、身体瘦长。",
    "人体：肝、筋骨、发、大腿、神经、气管。",
    "动物：蛇（注解：形态细长，攻击时呈直线）。",
    "植物：直冲云霄直线的 竹、树、高粱、玉米。",
    "地理：高大建筑物、公园。",
    "方位/色彩：东；碧绿。"
  ],
  "star:辅": [
    "核心原点 ①：辅助 → 帮助、辅佐与服务",
    "概念：帮助、辅佐、协助、指导、推荐。",
    "人物：总理、策划人、秘书、祝寿、导游、指导员、辅助人员。",
    "静物：帮助人的空调、风扇、窗口、绳子、电线、窗帘、衣服、筷子、桌椅、板凳、家具、雨衣、伞、床。",
    "地理：围墙、栅栏、隔离带、护栏、林荫路。",
    "核心原点 ②：阴木 → 温和、柔顺与植物",
    "形态：身体细长、发缜密、脸青白、手细长。",
    "性情：谦虚、仁慈面善、和谐融洽、柔顺。",
    "人体：大腿、呼吸器官、食道、神经、头发（注解：取其柔顺缜密之象）。",
    "动物：温顺的鸡、蛇、鸭、泥鳅、蚯蚓、蝴蝶、蜻蜓。",
    "植物：柳树、葡萄、葫芦、丝瓜、南瓜、杨树（柔顺、蔓藤类）。",
    "方位/天时/色彩：东南；风、旋风、彩虹、祥云；绿色。",
    "核心原点 ③：文化 → 文曲、科甲与修养",
    "对应北斗九星之文曲星。象征人物为孔子或文昌帝君，主文化、教育、科甲，以文德教化世人，辅助君王或百姓。",
    "来源：源自文曲星（天权），主管文运与科甲。",
    "概念：文化、教育、文运、科甲、艺术才华。",
    "人物：教师、教授、文化人、大文豪、大学生、博士。",
    "性情：文雅、有修养、有文化、有风度、君子之风。",
    "静物：书籍、文具、毕业证、文件、画作。",
    "地理：学校、考场、文化馆、图书馆。"
  ],
  "star:蓬": [
    "核心原点 ①：胆大好色",
    "对应北斗九星之贪狼星。最著名的形象为《西游记》中的天蓬元帅（猪八戒），生动诠释了“胆大好色”与“水性”的特点。",
    "在道教中它叫贪狼，代表欲望、生机与祸福之首。 贪狼主灵气与贪念，所以天蓬星的人通常胆大妄为、聪明绝顶。",
    "概念：聪明智慧、大胆妄为、心狠手辣、贪恋酒色。",
    "人物：妓女、盗贼、乞丐、黑社会、猎鱼者、投机倒把者。",
    "性情：圆融果敢、大胆妄为、贪婪、敢于冒险、喜欢暗中行事、多情多欲、贪酒恋花。",
    "核心原点 ②：蓬 → 蓬松、覆盖与庇护",
    "人物：头发蓬松的人。",
    "形态：庄严、威猛、彪悍、精干、面黑或眼大。",
    "人体：头发、足部。",
    "动物：多毛多厚的动物。",
    "植物：磨菇类、菌类植物、树冠大的树、大叶植物、蓬草类、刚出土的植物。",
    "静物：伞、雨具、渔具、船、车。",
    "地理：宫殿、亭子、庙宇、茅屋、简陋的房屋、四面通风的房子、破了门窗的房子、房顶、三角状的建筑、桥等。",
    "核心原点 ③：属水",
    "人体：耳、肾、膀胱、生殖系统、排泄系统、眼睛。",
    "动物：猪、鼠、蝙蝠、水生物等。",
    "方位/天时/色彩：北方；阴天、雨天、多云的天气、黑夜、冬天；黑色、蓝色、玄色。"
  ],
  "star:任": [
    "核心原点 ①：任 → 任劳任怨、驼背与承载",
    "概念：担当、承受、任劳任怨、任重道远。",
    "人物：驼背人、怕老婆、老诗人、长者、寿星、辛苦劳碌之人。",
    "形态：弯腰驼背。",
    "性情：忠厚老实、任劳任怨、倔强、勤奋，有韧性但固执、保守、小气、缺乏开拓精神。",
    "人体：手、腰、脊椎、腿。",
    "静物：桌子、椅子、被子、车子、柜子、鞋子。（注解：皆为承载之物）",
    "地理：桥、台阶、门槛。",
    "核心原点 ②：土 → 农民、敦厚与孕育",
    "人物：农民（农业生产者）、地产商、种植业者、矿山开采者、登山者、建筑者。",
    "形态：胸部丰满、方脸重眉。",
    "人体：鼻（注解：面部中岳）、胃、脾、腹部、男性生殖器、乳房。",
    "动物：肥大憨厚的牛、骆驼、虎、豹、狗、狼、猪、山中的动物。",
    "植物：农产品，山果，谷穗、稻子、黍子、葵花。",
    "地理：山丘、土包、丘陵、梯田、起伏不平的路等。",
    "方位/天时/色彩：东北方；云、雾、风沙；黄色。"
  ],
  "star:芮": [
    "核心原点 ①：问题 → 病灶、错误与缺陷",
    "为什么叫“芮”？因为草木萌芽（芮）时最容易产生病虫害，也最需要吸收养分。所以天芮星被定为“病星”。第二星“天璇”，道教称巨门。它像一道巨大的门，挡住了视线，因此主阴暗、隔阂、是非和财库。",
    "《烟波钓叟歌》云：“大凶蓬芮不堪使。”又曰：“天芮授道结交宜，行方值之最不宜。出行用事皆宜退，修造安坟祸转滋。”",
    "概念：问题、毛病、错误。",
    "人物：病人、产妇（注解：处于特殊的生理病理期）。",
    "性情：固执、迟钝、懦弱、阴险毒辣、贪婪无耻（精神上的“疾病”）。",
    "核心原点 ②：解决问题的人 → 师者、医者与管理者",
    "人物：教师、医生、图书管理。",
    "地理：学校、书店、医院（解决问题的场所）。",
    "静物：书籍（解决问题的工具）。",
    "核心原点 ③：联合 → 交往、结交与群体",
    "概念：联合、结交。",
    "人物：朋友、学生。",
    "地理：庭院、走廊、街道（人群交往的场所）。",
    "核心原点 ④：土 → 孕育、承载与田土",
    "人物：女神、大腹人（形态）、种田人、孕妇、地产持有人。",
    "形态：方脸、大嘴、肚子大、面色较黄、有雀斑。",
    "人体：脾、胃、腹部、肩部、嘴部。",
    "植物：庄稼、农作物、土豆、地瓜。",
    "静物：菩萨、女神（大地母亲的象征）、瓦罐、瓷器。",
    "方位/天时/色彩：西南；云、雾气、黄沙；黄色。"
  ],
  "star:心": [
    "核心原点 ①：心计 → 思想、策划与智慧",
    "第六星“开阳”，对应北斗九星之武曲星。象征人物为姜子牙或诸葛亮，身为帝王师，运筹帷幄，决胜千里，且心怀天下，济世救人。它主财帛、主刚毅，是实干家的代表。",
    "概念：思想活动、想法、情感、策划。",
    "人物：参谋助手、医卜星象之人。",
    "性情：聪明能干、精明机智、有领导才能、攻于心计、阴柔细腻、策划周密。",
    "人体：头、心脏（思想与情感中枢）。",
    "核心原点 ②：中心 → 领导、权威与核心",
    "概念：宇宙的中心。",
    "人物：领导、管理人员、指挥人员、核心人物。",
    "形态：圆形、高大、威严、雄伟。",
    "地理：领导办公室、影碑墙、堂屋、塔、大平原。",
    "核心原点 ③：仁心 → 医治、神佛与善行",
    "人物：医生、医药。",
    "性情：乐善好施、能惩恶助善。",
    "植物：菊花（药用）、草药。",
    "静物：神像、佛像。",
    "地理：教堂、寺院。",
    "核心原点 ④：金 → 贵重、刚健与收获",
    "五行：金。",
    "静物：金、银、珍珠、贵重物品。",
    "方位/天时/色彩：西北；冰雹、霜、雪；白色、金色。"
  ],
  "star:英": [
    "核心原点 ①：火 → 热烈、光明与能量",
    "五行：火。",
    "性情：声音焦脆、焦躁不安、易怒。",
    "人体：眼睛（采光）、血液（红色，热能）、心脏、小肠。",
    "静物：爆炸易燃物品、家用电器、烟花爆竹、太阳、霓虹灯、灯具。",
    "地理：高亢之地、阳光充足的场所、炉冶之地。",
    "方位/天时/色彩：南方；晴天、夏天、中午、闪电；红色。",
    "核心原点 ②：漂亮 → 美丽、艺术与文采",
    "概念：秀丽、美丽。",
    "人物：文艺工作者、演员、导演、画家、美容美发、作家。",
    "形态：瓜子脸、面红白、身体瘦、头发较黄。",
    "动物：孔雀、鹦鹉、火鸡、金鱼、热带鱼、等一切漂亮的动物。",
    "植物：开花的植物、盆景、花卉。",
    "静物：影视用品、证件、图片、图书。",
    "地理：美容院、语言学校、电影院、百货店、图书馆。",
    "核心原点 ③：英雄 → 卓越、智慧与杰出",
    "概念：卓越、杰出、贤明、智勇。",
    "人物：掌握核心技术的精英、电子产品经营制造者。",
    "性情：礼貌虚伪（注解：高情商、善于社交的表现）。"
  ],
  "star:柱": [
    "核心原点 ①：中流砥柱 → 支撑、顶立与中坚",
    "第七星“摇光”，是北斗的斗柄，指向哪里，哪里就是季节更替。",
    "概念：顶天立地、力挽狂澜、中流砥柱、能独当一面。",
    "人物：职业军警（国家的支柱）。",
    "形态：身体健壮。",
    "核心原点 ②：柱状 → 挺拔、细长与直立",
    "人体：中直部位、颈椎、腰椎、手指、大腿（身体的“柱状”支撑部分）。",
    "植物：直的树、芦苇、毛竹、胡杨。",
    "地理：钢管、水泥管、烟囱、线管、高塔、水塔、大厦、电线杆。",
    "核心原点 ③：声音 → 能言、善辩与发声",
    "其象为“破军金声”，天柱星在兑宫，属金，也有声音的意思。",
    "概念：口舌是非。",
    "人物：教师、律师、娱乐演艺人员、歌手。",
    "性情：能说会道、为能言善辩。",
    "静物：乐器、音响、喇叭、钟表（报时）、发声的物体。",
    "核心原点 ④：好斗（负面） → 惊怪与破坏",
    "对应北斗九星之破军星。它主破坏、开创、先遣。",
    "五行：金。",
    "概念：惊恐怪异、好战、破坏毁折。",
    "人物：检查官、纪检人员。",
    "性情：好斗争讼。",
    "方位/天时/色彩：西；秋天（肃杀）、雷电、冰雹；白色。"
  ],
  "stem:丙": [
    "核心原点",
    "核心原点 ①：阳火 → 希望、光明与热量",
    "丙的本象是太阳，是天地间阳气的源头，代表着光明、希望、温暖以及一切发光发热的实体。",
    "【光】",
    "概念： 希望、光明、雄威、正义、虚荣（渴望如太阳般被瞩目）。",
    "天时： 太阳、晴朗、炎热、夏季、中午。",
    "地理： 厨房、高岭、南方、炉冶、化工厂、煤炭、电厂、明亮场所。",
    "色彩： 红色、紫色。",
    "【热】",
    "静物： 光亮之物、灯、灶、发热之物、变压器、窗户（光的入口）。",
    "人物： 化工工人、司炉工、电厂工作者。",
    "感觉： 热、烫、痒。",
    "人体： 浮肿部位、炎症部位、斑点（体内火气失控的表现）。",
    "【人体】",
    "人体： 眼（感受光明）、血液（输送热能）、唇（常为红色）、心脏（人体的太阳）、小肠。",
    "形态： 少胡须、短发、皮肤白里透红（阳火旺盛之象）。",
    "核心原点 ②：乱子 → 刚猛、急速与失控",
    "当太阳之火的能量过于猛烈或失控时，便体现为破坏性的力量，即“乱子”，代表着急速、冲突和暴烈的状态。",
    "【乱子】",
    "概念： 乱子、刚猛、热烈、急速。",
    "性情： 暴烈、强悍、愤怒、性急、果断。",
    "人物： 脾气暴躁直人、果断刚猛之人。",
    "【爆炸】",
    "静物： 火箭、大炮。",
    "动物： 马、牛、猪、驴（体型大、能量足、性情刚猛）。",
    "核心原点 ③：权柄 → 权力、圆融与果实",
    "丙谐音为“柄”，象征权力与掌控；太阳的形态是圆的，其能量孕育的果实也多为圆形带柄，故引申出权威、圆融及带柄的物品。",
    "【权力象征】",
    "概念： 权威。",
    "人物： 当权者、有指挥能力。",
    "【圆融与果实】",
    "概念： 圆状、片状。",
    "形态： 体态丰满、圆脸。",
    "植物： 带柄的果实、梨子、樱桃、西瓜、南瓜、莲蓬、苹果。",
    "静物： 饼干、有栖之物（应为“有柄之物”的误记，指带把手的器物）。",
    "核心原点 ④：三奇 →",
    "情人关系常具有的热烈、激情、光明正大（或渴望光明）",
    "人物： 情人。"
  ],
  "stem:丁": [
    "核心原点",
    "核心原点 ①：阴火 → 光明、热量与智慧",
    "丁是阴火，不同于丙火的太阳之光，它是人间的、内在的、文明的火种，如灯烛、炉火与心中的智慧之光。它温暖、柔和但持久。",
    "【光与热】",
    "静物： 发光体、灯、弱热体、香火、电子产品、证件（常有防伪荧光）、烟火、打火机、灶。",
    "感觉： 热、烫。",
    "【人体】",
    "人体： 眼、心脏、血液。",
    "人物： 眼睛好的人。",
    "性情： 性情柔弱、和顺而有心计、体贴人情、洞察奸邪。",
    "形态： 主人秀丽清高、肤白粉嫩、发细而长（阴火柔美之象）。",
    "核心原点 ②：钉子 → 尖锐、突出与叮刺",
    "丁的发音（Dīng）与“钉”（Dīng）完全相同，其字形也如同一颗钉子。因此，它代表一切尖锐、突出、带刺或有“叮咬”行为的事物。",
    "【尖锐】",
    "概念： 尖锐、逼人、带刺。",
    "人体： 牙、骨刺、肉刺、男性生殖器。",
    "静物： 刀、针、剑、注射器、钉子、牙签、拐杖、炮弹、子弹、小型金属物件、首饰。",
    "形态： 额宽颏尖（丁字脸）。",
    "【突出】",
    "概念： 顶尖、突出。",
    "人物： 技术一流之人、表现突出之人、歌星。",
    "地理： 路口（丁字路口）、房檐、屋角、房顶、塔、高岗。",
    "【叮刺】",
    "人物： 说话带刺之人。",
    "动物： 叮咬人和动物的昆虫（蚊子、跳蚤、马蜂、蜜蜂、牛虻）、带刺的动物（刺猬、野猪、蛇）。",
    "植物： 带刺的植物或果实（玫瑰、月季、槐树、仙人掌、松树、石榴、板栗、毛丹、枣树、榛子）。",
    "核心原点 ③：三奇 → 希望、情人与文书",
    "丁是“天上三奇”（乙、丙、丁）之一，代表奇迹、机遇和希望。在人际关系上，它特指亲密而深刻的情感联结，如情人；也引申为重要的凭证。",
    "【希望】",
    "概念： 希望、执著、发展。",
    "【情人】",
    "人物： 情人、妓女（丁火有夜晚、隐秘、烛光交易的象意）。",
    "【订正】",
    "静物： 票据、文章（思想的结晶，带来机遇）。"
  ],
  "stem:庚": [
    "核心原点",
    "核心原点 ①：阳金 → 坚硬的物质实体",
    "庚是阳金，是世间一切坚硬、刚强的物质基础，从自然界的矿石到人造的金属器械，再到人与动植物的支撑骨架，都属于庚金的范畴。",
    "【金属与矿石】",
    "静物： 石头、石制品、石兽、门窗、骨类、刀枪器械、汽车、金属制品。",
    "地理： 道路、钢铁厂、矿山机械。",
    "【身体与形态】",
    "人体： 头骨、骨骼、肺、大肠、皮毛、肩背。",
    "形态： 形体瘦长、骨格健壮、长脸白皮肤、筋强骨健。",
    "【植物】",
    "植物： 植物的干、根、果壳等。",
    "核心原点 ②：凶恶 → 肃杀的对立与冲突",
    "庚在奇门遁甲等术数中常作为“值符”的对立面，是天生的“反派”角色，代表着阻碍、关卡与变革前的破坏力。它是一切冲突、斗争与凶险事物的总代表。",
    "【阻碍】",
    "概念： 阻碍、阻隔、斗打、肃杀、凶恶、野蛮。",
    "感觉： 疼痛。",
    "【执行者】",
    "人物： 军警、黑社会、凶残之人、武断之人（注解：军警与黑社会都代表强制性的暴力机器，是一体两面）。",
    "动物： 凶恶的动物、老虎、狼、狮子、豹子、毒蛇、生物病毒等。",
    "【冲突场所】",
    "地理： 关卡、收费站。",
    "核心原点 ③：技术 → 刚健的魄力与能力",
    "庚金的坚硬特质，也引申为一个人安身立命的“硬本领”和坚忍不拔的意志力。它代表着千锤百炼后形成的过硬技术和刚健魄力。",
    "【能力与品质】",
    "概念： 魄力、气概、刚健、技术过硬。",
    "性格： 刚健敏锐、坚忍不拔、威严残暴、性刚质硬。",
    "【拥有者】",
    "人物： 武术、本领高强之人。"
  ],
  "stem:癸": [
    "核心原点",
    "核心原点 ①：阴水 →",
    "癸是阴性的水，如雨露、溪流、津液，其特性是渗透、滋润、持续但微小的流动。它是一切喜水生命的源泉，也代表着生活中的各类液体。",
    "概念： 流动、变动、变化。",
    "人物： 瓜农、菜农、茶农（需要阴水灌溉的职业）。",
    "动物： 水鸟、鸭、鹅、雁、鹤、鹬、鹭（生活在湿地池塘的动物）。",
    "植物： 水稻、蔬菜、水果、水仙、喜水植物。",
    "静物： 酒、醋、盐、茶、饮品、油漆、汤、液体物品、水具。",
    "地理： 湿地、池塘、水塔、地下水。",
    "感觉： 麻凉（雨水的触感）。",
    "核心原点 ②：性",
    "癸水对应人体最阴私的体液和器官，是生命的根本精元，也由此引申出与性、欲望相关的隐秘之事。",
    "概念： 性、淫。",
    "人物： 淫荡之人。",
    "人体： 足（身体最下方，属阴）、私处、静脉（相对于动脉为阴）、肾脏（水脏）、眼球、精液、痣、口水、眼泪、鼻涕、汗液、尿溺（注解：几乎囊括了人体所有体液）。",
    "地理： 淫秽场所。",
    "核心原点 ③：困难",
    "癸水也是被困住的水，如井水、地沟水、牢狱中的污水，象征着被限制、被管束的艰难困苦。这种状态下的人，往往显得弱小、无助。",
    "概念： 制约、管束、艰难困苦、跋涉。",
    "人物： 囚犯、被困之人、穷困潦倒之人；酒鬼（被嗜好所困之人）。",
    "形态： 矮小黑丑、圆脸瘦肩、声调不高（受压抑的外在形象）。",
    "性情： 阴柔怕事、多愁善感、不能自主。",
    "静物： 鞋（用于艰难跋涉）。",
    "动物： 黑蝇（注解：常与污秽、停滞的环境相关）。",
    "地理： 地沟、地井、污水、粪池。"
  ],
  "stem:己": [
    "核心原点",
    "核心原点 ①：阴土（坑） →",
    "己是阴性的、湿润的、肥沃的田园之土。它代表着低洼、垃圾，同时也与消化、排泄后的污秽之所相关联。",
    "【地理】: 坑、沟、厕、下水道、垃圾、湿地、坟地、墓场、田园、低洼地、明堂、阳台、肮脏污秽之物。",
    "【静物】: 土制泥制陶制工艺品、食物、垃圾、大便等。",
    "【人体】: 嘴（入口）、脐、肛门（出口）、脾、肠（消化承载器官）。",
    "【感觉】: 沉重。",
    "核心原点 ②：弯曲 → 卷缩",
    "己的字形和象意都充满了“弯曲”和“卷缩”的形态，如同盘旋的绳索或休眠的动物。它引申为一切物理上或行为上不直接、不伸展的状态。",
    "【形态】: 形体单薄，瘦弱丑陋（有蜷缩、不舒展之感）、圆脸。",
    "【人物】: 打坐的人、身体屈尊的人、握手抱拳之人（身体姿态的弯曲）。",
    "【动物】: 蜗牛、章鱼、墨鱼、卷曲身子的动物、身体过度弯曲的动物、休眠的动物（如蛇、熊、猫狗等）。",
    "【植物】: 卷曲没有展开的植物、含苞待放的花蕾（如圆白菜、菊花、含羞草、植物的芽）。",
    "【静物】： 绳索、线团。",
    "【概念】: 拐弯抹角、杂乱（线团般杂乱）。",
    "核心原点 ③：策划 → 欲望、心计",
    "由“弯曲”的物理形态，引申出思维上的“花花肠子”。这种内在的、复杂的、不为人知的心理活动，表现为周密的计划、细腻的思考，也包括欲望和邪念。",
    "【概念】: 策划、欲望、邪念、创意、花花肠子、节约、吝啬、有主意、想法多、忌讳多、思考问题细心。",
    "【人物】: 诸葛亮式的人物、策划人、广告人、妓女（与欲望和心计相关）、爱吃零食的人（被欲望驱动）。",
    "【性情】: 忧愁之相、声音含糊重浊（心事重重）、静多动少、温顺沉静（内心活动丰富）。"
  ],
  "stem:甲": [
    "核心原点",
    "核心原点 ①：第一",
    "（此逻辑源于甲为“十干之首”的序位。它代表一切处于顶端、最有钱、最有权、最有名的的人事物。）",
    "概念： （最）高贵的、有名望的、第一的、首领",
    "人物： 领导人、经理、董事长、将军、元首、名人",
    "性情： 威严、正直、愉快、独断、心高（皆为领导者特质）",
    "地理： 省会、首都、领导办公室、名人居所、机关、高大建筑物",
    "食物： 馐珍、美味、高档食品",
    "核心原点 ②：阳木 → 大木",
    "（此逻辑源于甲的五行属性“阳木”。它就像一棵参天大树，笔直、坚挺、充满生命力，与自然界的生长息息相关。）",
    "形态： 伟光正，直、方、高；人体形长方，筋骨强健",
    "人体： 头、大脑（身体的顶端）、肝、胆、筋（木所主）",
    "植物： 大树",
    "地理： 无烟烟囱、粗柱子、房梁、高亢之地",
    "色彩： 青色、绿色",
    "核心原点 ③：铠甲 → 坚硬、包裹与保护",
    "（此逻辑源于“甲”的字形与本意，即“铠甲、甲壳”。这是甲最独特、最关键的象意，引申为一切带有坚硬外壳、起保护作用的事物。）",
    "人体： 指甲、头发（人体的“甲”）",
    "动物： 穿山甲、玳瑁、龙虾、乌龟、鳖、贝类、螺类、螃蟹（所有带硬壳的动物）",
    "植物： 带壳的果实（花生、核桃、松子、栗子、菱角、瓜子）",
    "静物： 帽子、甲胄、背心、盔甲、盾牌、车船的外壳（直接的保护物）、金、玉、珠宝、古董、文物（贵重且需保护之物）",
    "地理： 棺材（人生的最后一个外壳）"
  ],
  "stem:壬": [
    "核心原点",
    "核心原点 ①：阳水 → 流动、迁移与变化",
    "壬是阳性的大水，如江河奔腾，其最根本的特性就是永不停息的流动。这引申出一切与宏大移动、交通、变迁相关的人、事、物。",
    "概念： 流动、迁移、变化。",
    "人物： 旅游者、航海者、海员、渔猎者。",
    "地理： 江、河、湖、海、道路、人流、车站、码头、机场、电影院、娱乐场所、礼堂、会堂、饭店。",
    "静物： 水池、自来水、洗手间、厨房、水管、水线等、消防用品。 被子、窗帘、灯罩（流动）。",
    "人体： 动脉（血液的流动）、小腿（支撑人体的流动）。",
    "形态： 走路摇摆（形态模仿水的流动）。",
    "动植物： 水中物、鱼、虾、蟹、龟等；荷花、菱角、海带、海草等。",
    "核心原点 ②：壬 (rén) ≈ 妊 (rèn) → 孕育、生产与包容",
    "壬的发音与“妊”（怀孕）相近，这是其“孕育”象意的直接来源。它代表着包容、蕴藏、生产，是生命与新事物的温床。",
    "概念： 孕育、蕴藏、生产。",
    "人物： 孕妇、水产者、养殖者。",
    "人体： 膀胱、宫胞（注解：均为容纳、孕育的器官）。",
    "性情： 容纳。",
    "核心原点 ③：智慧 → 思想、谋略与柔顺",
    "正：源于“上善若水”，水深则静，静则生慧。壬水深邃广博，象征着内在的思想深度、谋略与以柔克刚的力量。",
    "概念： 智慧。",
    "形态： 皮肤稍黑（水色）、大眼睛、双眼皮、长发秀眉（神采与智慧的外显）。",
    "性情： 柔顺、勇敢、多智、热情、威严。",
    "人体： 发（肾之华，肾主智）、眼（智慧之窗）、心脏（心主神明）",
    "负：迷茫 → 困境、纵欲与失控",
    "迷茫，源于大水无边无际、深不见底的形象，使人迷失方向，陷入困境。水性的符号都跟性有关，它也代表欲望如洪水般泛滥，导致人沉沦、失控。",
    "概念： 迷茫、困境。",
    "人物： 风流、流氓（欲望泛滥，迷失自我）。",
    "地理： 监狱（禁锢流动的地方）、",
    "感觉： 胀痛（被充满、无法疏导）。",
    "性情： 阴险、纵欲、任性。"
  ],
  "stem:戊": [
    "核心原点",
    "核心原点 ①：阳土（山） →",
    "戊是阳土，代表广阔、坚固、静止的大地、山峦与城墙。它引申为一切由土构建的、具有承载和保护功能的场所与物品。",
    "【五行】",
    "五行： 阳土。",
    "概念： 中正、厚德载物、包容。",
    "【地理与建筑】",
    "地理： 庭院、起居室、客厅、墙壁、水泥横梁、堤防、坟地、陵园、土地、水泥厂等。",
    "【土制器物】",
    "静物： 陶制品、土制品、瓷碗、瓷杯、瓷勺、瓷盆、瓷缸、砖瓦、水泥制品等。",
    "【人体与感觉】",
    "人体： 胃、脾、腹部（中医里土主运化，对应中焦脾胃）。",
    "感觉： 沉重。",
    "核心原点 ②：大肉 →",
    "戊土厚重广博，其形态表现为敦实、丰满、方正、肉多。此象意延伸至体型庞大敦厚的动物，以及叶片宽大或果实肉质的植物。",
    "【形态】",
    "形态： 形体敦厚、四方脸、肤黄白、身体多肉。",
    "【人体】",
    "人体： 鼻、胸、乳房、臀部（身体丰满肉多的部位）。",
    "【动物】",
    "动物： 牛、猪、骆驼、狗熊、企鹅、熊猫等（皆为体型敦厚、行动显沉稳的动物）。",
    "【植物】",
    "植物： 叶子宽厚方大或土生的肉质多的果实（如芭蕉、向日葵、杨树、南瓜、倭瓜、白薯、土豆、山药、萝卜等）。",
    "核心原点 ③：憨厚 →",
    "戊土的性情如大地般忠厚、守信，但也因其固重不变，而有愚笨、迟缓甚至刚烈暴躁的一面（山之不可移，一旦爆发则如山崩）。",
    "【正面性情】",
    "概念： 守信、忠诚、直方大。",
    "人物： 从农者、德高望众之人、宽厚中庸之人。",
    "【负面性情】",
    "性情： 果敢豪杰（山岳般稳重果决）、刚烈暴躁（土的固执与爆发）、憨厚、愚笨、痴呆、行动迟缓。",
    "核心原点 ④：金钱 →",
    "【金融】 土生金，有地就是有钱",
    "概念： 资本、钱财、金融。",
    "人物： 会计、金融机构、出纳、银行职员、地产商。",
    "核心原点 ⑤：平台 → 中介与载体",
    "戊土广阔，能承载万物，如同一个巨大的平台。因此，它象征着资本的聚集地（如银行）、信息的中转站（如中介）和资源的开采者。",
    "【中介】",
    "人物： 中介人、矿山开采者。",
    "地理： 中介所、顾问机构。",
    "人物： 妓男（注解：作为满足他人需求的物理“载体”或服务“平台”，带有交易属性，故归于此）。"
  ],
  "stem:辛": [
    "核心原点",
    "核心原点 ①：阴金 → 珠宝、晶体与贵重品",
    "辛是阴性的、被加工过的、小巧精致的金属。它代表一切小型的、贵重的、颗粒状的物品，如同珠宝、首饰和粮食，是财富与秀气的象征。",
    "【贵重物品】: 小型的金属物品、饰品、艺术品、戒指、项链、手镯、小摆件、钥匙、螺丝、佛珠、手表、金银珠宝、小刀、贵重物品、金钱、印章、保险柜、工程塑料等小型制品。",
    "【颗粒与花果】: 颗粒状粮食（如：大豆、高粱、玉米）、小型花朵（如：茉莉、米兰）、花果、动物的卵或胎坯。",
    "【形态与性情】: 修长方正、皮肤白嫩、长脸凹腮；忠诚爽柔、温润秀气、自尊但虚荣、意志稍不坚。",
    "【相关地理/天时】: 五金加工厂、手表厂、首饰厂、工艺品厂、门窗（特指锁具、合页等小五金）、石块、水泥；星星、秋天、傍晚、西方；白色、粉色。",
    "核心原点 ②：错误 → 问题、病灶与罪错",
    "它代表着概念上的错误、法律上的罪错，以及身体上令人疼痛的微小病灶。",
    "【概念与感觉】: 错误、问题；疼痛。",
    "【人物】: 罪人、犯法者。",
    "【人体病灶】: 牙、骨（特指骨刺等病变）、肺、皮毛、疙瘩、瘤、骨刺、湿疹、粉刺、痘。",
    "【微小侵害】: 寄在人或动物身上的生物或病毒、直径不超过一厘米的虫类。",
    "【终结之象】: 骸骨、尸体（生命的终结，可视为最终的“错误”或“问题”状态）。",
    "核心原点 ③：变革 → 创新、革命与更新",
    "发现“错误”是“变革”的开始。辛金代表了修正错误、推陈出新的强大动力。这种力量可以是颠覆性的叛逆与革命，也可以是温和的创新与自我更新。",
    "【概念】: 叛逆、创新、变革、更新。",
    "【人物】: 革命者、改革之人、宗教徒（注解：寻求自我革新与灵魂净化的人）。",
    "【天时】: 雷电（注解：大自然中突如其来的变革与能量释放）。"
  ],
  "stem:乙": [
    "核心原点与象意归类",
    "核心原点 ①：阴木 →",
    "五行： 阴木",
    "人体： 肝、胆 (木在脏腑)",
    "感觉： 酸胀 (木之味)",
    "植物： 小树、草地、花园、果林、菜园 (阴木所代表的植被群落)",
    "核心原点 ②：象形 → 弯曲柔软",
    "（源于“乙”字本身以及其代表的藤蔓形态，所有“细长、柔软、弯曲、缠绕”的事物都归于此。)",
    "概念： 质软、弯曲、曲折",
    "形态： 苗条、微驼身、骨肉松弛、瘦长脸",
    "人体： 肠、神经、淋巴、手、足、肩、颈、臂、腿、头发、输卵管、输精管、阴道、阴茎",
    "动物： 蚯蚓、蛇、海参、海肠、蚕虫、龙、鸟类(形体弯曲)",
    "植物： 藤蔓、柳枝、牵牛、黄瓜、爬山虎 (形态弯曲)",
    "静物： 管道、拐弯之物、楼梯、面条、绳索、线缆",
    "核心原点 ③：女人 → 阴柔依附",
    "概念： 依附",
    "人物： 女人、妻子",
    "性情： 依赖、犹豫、敏感、自私、逆来顺受 、仁慈、柔弱、仁爱、柔情、善人、柔顺",
    "核心原点 ⑤：谐音 → 艺 (文化创造)",
    "（源于“乙(yǐ)”与“艺(yì)”的谐音，所有与“美丽、艺术、文化、才华、装饰”相关的事物都归于此。)",
    "概念： 艺术、文化",
    "人物： 艺人、画师、作家",
    "植物： 花草、水果树、龙爪槐 (观赏性、美丽)",
    "静物： 漂亮的雕梁画柱、美丽的艺术品、葫芦、木雕、图画、装饰性强的物品、漂亮的房间、门、窗、藤椅",
    "地理： 艺术馆、漂亮的建筑物",
    "核心原点 ④：谐音 → 医 (疗愈功能)",
    "（源于“乙(yǐ)”与“医(yī)”的谐音，以及乙奇代表的“希望、生命力”，所有与“治疗、药物、健康、转机”相关的事物都归于此。)",
    "概念： 希望达成、转机",
    "人物： 中医、医生",
    "植物： 中草药 (医药的根本)",
    "地理： 美容院 (广义的疗愈和修复)"
  ],
  "trigram:兑": [
    "核心原点 ①：少女",
    "解释：兑为少女，象征着青春的喜悦、纯真的爱意和天生的魅力，引申为一切带来快乐、和睦与感官享受的活动。",
    "概念：舞会、庆典、娱乐、色情、恩惠、和睦、敬爱、爱欲、魅力。",
    "性情：喜悦、开朗、爱欲、亲热、温和、多愁善感、重情讲义、忧愁。",
    "地理：游乐场、娱乐场、影剧院。",
    "人物：少女、年轻女性、空姐、坐台小姐、小女孩、性魅力者、欢乐性职业。",
    "动物：羊(温顺)、兔子(可爱)。",
    "食物：兔肉、羊肉、奶油。",
    "人体：女性器官、胸部。",
    "疾病：神经衰弱(多愁善感)、性病、贫血。",
    "核心原点 ②：口舌",
    "解释：兑卦上缺，其形如口，因此一切与口的功能相关的事物——说话、辩论、唱歌、饮食——都归于此。",
    "概念：口舌、议论、饮食、酒食、唱歌、接吻、雄辩。",
    "性情：口舌是非、拍马屁奉承、口馋。",
    "地理：咖啡馆、茶馆、饭店、音乐厅、公关部、会议室。",
    "人物：歌手、话务员、教师、律师、讲解员、翻译、厨师、牙医、巫师、媒婆、神汉、导游、相声演员、经销人员、评论家、音乐家。",
    "食物：辣味食品(刺激口腔)、啤酒、汤类。",
    "静物：乐器(发声如口)、带口之物、邮筒。",
    "人体：口、舌、牙齿、涎、气管、咽喉。",
    "疾病：口腔疾病、牙病、舌病、咽喉病、咳嗽。",
    "姓字排行：带口字傍姓氏。",
    "核心原点 ③：金——锐利",
    "解释：兑的五行为金，代表秋天的肃杀、金属的锐利、坚硬和贵重，以及其对应的颜色与方位。",
    "概念：机敏(思维锋利)。",
    "形态：外软内坚、坚硬的、顽固的、昂贵的、金黄色的、发光发亮的、光滑的、锋利的。",
    "地理：西方。",
    "动物：虎、豹(爪牙锐利)。",
    "食物：石榴、胡桃(外壳坚硬)。",
    "静物：财宝、金银首饰、五金工具、金属制品、刀剑、剪刀、手术刀。",
    "人体：肺、右肋、右肩臂、大肠(五行属金)。",
    "疾病：气喘、胸部疾病、结核病(肺金之病)。",
    "时间：秋天、八月、酉年、月、日、时。",
    "色彩：白色、浅黄、金色、金黄色。",
    "姓字排行：带金字傍姓氏、排行2、7。",
    "核心原点 ④：湖泽",
    "解释：“兑为泽”，代表低洼汇水的沼泽湖泊，象征一切湿润、凹陷的地理环境及生于其中的万物。",
    "天时：潮湿的天气、气压低、露水、阴雨连绵、小雨。",
    "地理：沼泽地、峡谷、泽覃、湖泊、池塘、滑冰场、井坑、洞穴。",
    "动物：泥鳅、猿猴(居于峡谷)、水鸟、仙鹤、沼泽动物。",
    "植物：荷、水草、菱、芦苇、水稻、蔬菜。",
    "食物：泥鳅。",
    "疾病：皮肤病(湿气所致)、尿道病、膀胱病。",
    "核心原点 ⑤：破损",
    "解释：兑卦上爻为阴，是“上缺”之象，代表不完美、破损、缺陷，以及一切带有开口的器物。",
    "概念：伪善(品德的缺陷)。",
    "形态：上面开口。",
    "天时：新月(有缺之月)、黄昏、星。",
    "地理：小路、小巷、路口、门口(均为通路开口)、废品收购站。",
    "静物：破损物、垃圾箱、锅、碗、瓢、盆(皆为开口器物)。",
    "人体：肛门。",
    "疾病：受伤、打伤、创伤。"
  ],
  "trigram:艮": [
    "核心原点 ①：止",
    "解释：艮的本义即“止”，代表事物的停止、阻碍、断绝和等待的状态。",
    "概念：静止、断绝、呆板、等待、困难、迟滞、阻隔、艰难。",
    "形态：停止不前的、独立存在的、静止的。",
    "地理：监狱、派出所。",
    "人物：犯人、孤独人。",
    "静物：门户、门坎、台阶、座位、屏风、墙壁。",
    "疾病：筋骨酸痛、消化不良、虚弱、小儿麻痹症、疮肿、瘤、结石、疑难症、虚胀、麻木、痘类疾病(多为凝滞不通)。",
    "核心原点 ②：山",
    "解释：艮的卦象为山，代表一切高高凸起的地貌、建筑以及作为界限的事物。",
    "形态：坚硬的、顽固的、与腿脚有关的、向下发展的、上硬下软的。",
    "天时：阴天、云彩、雾气、山岚。",
    "地理：东北方、丘陵、坟墓、山地、高坡、桥梁、堤坎、休息室、大楼、仓库、宗庙祠堂、矿山、采石场、银行。",
    "人物：山中人、肥胖人、仓库管理、土建人员、矿工、房地产商。",
    "动物：老虎、狼、熊、狗、鼠、狐、鸽子、喜鹊、啄木鸟、爬虫、有尾动物。",
    "静物：岩石、山坡、阶梯、石碑、土坑、椅子、桌子、床、土中之物、石刻、石块、瓷器。",
    "人体：背、腰、鼻、手、指、关节、左腿、脚腕、脚趾、乳房、脾、胃、结肠、男性生殖器。",
    "疾病：脾胃病、皮肤过敏。",
    "时间：冬春之交、丑、寅年、月、日、时。",
    "色彩：黄、棕、咖啡、棕黄。",
    "姓字排行：土字傍姓氏、排行五、七、十、八。",
    "核心原点 ③：稳固",
    "解释：山体稳固厚重，引申为稳定、固守、诚实守信的品格，以及保守、固执不变通的性情。",
    "概念：稳定、固守、慎重、诚实、守信、安定。",
    "性情：保守、固执、憨厚、稳重、诚实、守信、谨慎、迟缓、安静、笃实、任劳任怨。",
    "形态：保守的。",
    "人物：宗教人员、信徒、保守者、警卫、贵族、法官、家具商。",
    "核心原点 ④：少男",
    "解释：艮为少男，代表终点之后的新生力量，象征着事物的开始、变化、转折与希望。",
    "概念：开始、变化、转折、改革。",
    "人物：少男、儿童、学生。",
    "植物：瓜类、黄色植物、萝卜、甘薯、土豆、花生、木耳、冬瓜、丝瓜(皆从土中生)。",
    "食物：牛肉、兽肉、根类食物、山蘑、山中采集的食物、汤圆、甘薯、糖果。",
    "静物：瓜果、木生之物。"
  ],
  "trigram:坎": [
    "核心原点 ①：险陷",
    "解释：坎卦上下皆阴，一阳陷于其中，是为“险”。代表陷入困境、遭遇灾难、劳苦与病痛，是人生道路上的艰难险阻。",
    "概念：劳苦、艰难、苦难、险阻、烦恼、陷落、沉溺(指困境而非情欲)、毒害(指物质毒害)、灾难、踌躇、缺陷、失败、困难。",
    "形态：辛苦劳碌的、忍耐的。",
    "地理：医院。",
    "人物：孕妇(身负重担)、盗贼、匪人、逃亡者、黑社会人物、酒鬼、诈骗犯、吸毒者。",
    "静物：毒药。",
    "人体：血液、体液、骨髓。",
    "疾病：怕冷、水肿、疮、中毒、血行不畅、脚部疾病、神经衰弱、抑郁症、糖尿病、血液病、髓坏疽、风寒、拉肚子、流感等。",
    "核心原点 ②：性",
    "解释：坎为水，有交合、渗透之象，一阳陷于二阴之中，是欲望与沉溺的体现。代表男女情事、生殖繁衍以及由此带来的诱惑与危险。",
    "概念：色情、诱惑、沉溺(指情欲沉溺)、交合、关系。",
    "地理：妓院、酒吧、娱乐场所、洗发房。",
    "人物：娼妇、中男、多情之人。",
    "人体：肾、膀胱、泌尿系统、生殖系统、阴部、子宫、卵巢、尿道、生殖器、内分泌系统。",
    "疾病：肾病、月经不调、花柳病、性病、妇女病、遗精、膀胱病、尿道病。",
    "核心原点 ③：流动",
    "解释：水的本性是流动、渗透和交融，无孔不入。因此代表着一切流动变化、交通往来以及人际关系的结合。",
    "概念：交际、交往、结合、漂泊、时尚(潮流)。",
    "形态：不规则形状的、流动的、变化的。",
    "天时：雨、雪、云、露、霜、水、寒风、霞。",
    "地理：江河、湖海、溪涧、泉、井、沟渠、洼地、潮湿、下水道、鱼池、浴池、车站、码头、渔场、水库、洗手间、厨房、厕所。",
    "人物：船员、驾驶员、江湖之人、水产经营者、流动性强的职业、劳务打工人员、旅游家。",
    "动物：四足动物、水鸟、鱼类、水中动物。",
    "植物：水草、海草、荷花、水仙、菱角、芦苇、冬梅等。",
    "食物：莲藕、酒类、饮料、糖浆、汽水、果汁、海带、生鱼片、盐、酱油、醋、梅杏李、海产品。",
    "静物：带子、绳子、裙子、液体、饮料、酒油、汤具、水具、涂料、冷藏设备、消防设备、潜水艇、浮萍、轮子、船。",
    "核心原点 ④：阴暗",
    "解释：水在深渊则黑暗，在北方则寒冷，在夜里则与月光相应。代表着一切阴暗、寒冷、隐藏和不可告人的事物。",
    "概念：暗昧、沉默、隐伏。",
    "形态：暗昧的、寒冷的。",
    "天时：深夜、月。",
    "地理：北方、黑暗的家、地下室。",
    "动物：猪(性喜阴湿)、狐狸、夜行动物、鼠。",
    "食物：猪肉。",
    "静物：黑色物、带核果品(内有核心)。",
    "人体：耳、肛门。",
    "疾病：耳病。",
    "时间：冬十一月、子年、月、日、时。",
    "色彩：黑色、紫色。",
    "姓字排行：点水傍姓字，排行一、六。",
    "核心原点 ⑤：智慧",
    "解释：水利万物而不争，深不可测，象征着内在的智慧、谋略、艺术与深沉的情感。",
    "概念：测量、思考、滋润、仁慈、智慧、聪明、狡诈。",
    "性情：善谋多智、独立见解、创新思维、外柔内刚、随波逐流。",
    "地理：消防队(用水之智)、电影院、俱乐部(精神娱乐)。",
    "人物：医生、教育工作者、科学家、宗教家、心理学家、画家、作家。",
    "食物：骨头(藏于内，支撑身体，如智慧支撑人)。",
    "静物：音像制品、文具、墨水。"
  ],
  "trigram:坤": [
    "核心原点 ①：大地",
    "解释：坤的本象为大地，代表一切与土地相关的属性，如承载、方形、广阔、以及由土制成的物品。",
    "概念：大地、方形、开阔、稳健、踏实、伏藏、包容、含蓄。",
    "形态：方形、粗笨、能容、黄色、粉状、平整。",
    "天时：温暖。",
    "地理：西南方、原野、田野、平地、盆地、空地、旷野、矮屋、下方、底层、庄稼地。",
    "静物：瓷器、方形物、水泥、砖瓦、土中之物、锅瓦。",
    "人体：腹、脾脏、胃、肚脐、肌肉、消化器官。",
    "疾病：胃病、消化系统疾病、黄疸、皮肤病。",
    "色彩：深黄、黑。",
    "姓字排行：带土姓人，行位八、五、十、二。",
    "核心原点 ②：母亲",
    "解释：坤为老母，是纯阴之体，象征着母亲般的柔顺、谦卑、慈悲与滋养万物的品德。",
    "概念：柔顺、平安、文雅、勤俭、谦卑、依赖、慈悲、安静、温厚。",
    "性情：温柔谦虚、守信诚实。",
    "形态：柔软、虚空、包容的。",
    "人物：母亲、妻子、妇人、皇后、领导夫人、奶奶、女领导、胖女人、大腹人、忠厚之人。",
    "动物：牛、羊、牝马。",
    "植物：苔、茸、蕨、芹菜、柿子。",
    "食物：糙米、小麦、面粉、长于土中的食物、内脏类食物。",
    "静物：方柔之物、五谷、布帛、丝棉、药品、妇女用品。",
    "人体：女性生殖器、肠。",
    "疾病：贫血、下体流血、虚脱、浮肿、慢性病。",
    "核心原点 ③：众庶",
    "解释：大地承载万民，引申为群众、百姓以及他们的生产生活、所用之物和聚集之所。",
    "概念：沉默。",
    "形态：普通、共用、数多。",
    "地理：乡村、农村、牧场、农舍、民房、农贸市场、集会场所、办公室、公园、仓库、寝室、肉类加工厂、鸡窝、兔圈、操场。",
    "人物：副手、助理、职员、书商、地产商、建筑工人、农民、群众、房地产、农牧业经营者、秘书。",
    "动物：蚂蚁、蜘蛛、乌鸦、鸽子、海鸥、雌性百兽。",
    "食物：肉类。",
    "静物：衣服、大车、日用品、农具、书包、纸张、汽车等。",
    "人体：右手、右肩、耳。",
    "核心原点 ④：忧虑",
    "解释：纯阴至极也代表着被动、迟缓、无主见，从而引申出迷惘、忧虑、懦弱等消极状态。",
    "概念：迷惘、忧虑、迟缓、消极、沉默、优柔、寡断、懦弱、卑贱、丑陋。",
    "性情：行动迟缓、吝啬消极、固执保守。",
    "天时：多云、阴天、雾气、露水、低气压。",
    "地理：殡仪馆。",
    "人物：寡妇、胆小人、消极人、丑陋人。",
    "动物：夜行动物。",
    "疾病：食欲不振、过度疲劳、失眠、恶心、消化不良、下痢、便秘、肩周炎、恶死、伤寒、健忘、皮肤斑、晕症、癌症。",
    "时间：农历六、七月、辰戌丑未月、未、申年、月、时。"
  ],
  "trigram:离": [
    "核心原点 ①：火",
    "解释：火是离卦的本象，代表光、热、电等一切可见、发热、迅速变化的能量形态。",
    "概念：光明、变化、迅速、流行、时尚、警惕(目光如炬)。",
    "形态：鲜艳的、明亮的、发光的、可燃的、冒火的。",
    "天时：太阳、晴天、热天、中午、干旱、光、闪电、云霞。",
    "地理：南方、朝阳的场所、天文台、电子产品、冶炼厂、火车站、火山、电厂、广告牌。",
    "静物：电灯、电话、打火机、手机、电动机、电气焊工具、电子电器产品。",
    "人体：眼睛、血液、心脏、神经。",
    "疾病：心脏病、眼疾、视力减退、近视、色盲、头痛、烫伤、热症。",
    "时间：夏天、农历五月、午年、月、日、时。",
    "色彩：红、赤、紫色、花色。",
    "核心原点 ②：美丽",
    "解释：“离者，丽也。” 火光依附于物体而显现，引申为一切依附于外表的装饰、文采与美丽。",
    "概念：美丽、尊敬、化妆、妆饰、文才、判断、鉴定。",
    "性情：聪明、名誉、重礼、爱美、喜欢装扮、知书达理、易冲动、性急暴躁。",
    "地理：娱乐厅、电影院、华丽街道、美容院、画廊、殿堂。",
    "人物：中年妇女(离为中女)、美人、明星、中层干部、美容师、画家、摄影者、快活、艺术家、多情人。",
    "动物：雉、孔雀、火鸡、热带鱼、萤火虫、变色龙。",
    "植物：花朵。",
    "食物：红色食物。",
    "静物：化妆品。",
    "人体：乳房。",
    "核心原点 ③：空虚——甲壳",
    "解释：离卦外阳内阴，是“外实内虚”之象，代表一切有硬壳、外表华丽而内里中空或虚幻的事物。",
    "概念：外刚内柔、枯燥、空虚、暴露、虚伪。",
    "性情：虚心、内心空虚。",
    "形态：中空的。",
    "动物：龟、蚌、蟹、甲壳虫。",
    "植物：竹子、椰子、带壳的果实。",
    "食物：烧烤类食物(内部水分被烤干)、贝类、蟹、虾。",
    "静物：锅炉、玻璃门窗。",
    "人体：头部、小肠、女人私处。",
    "疾病：精神疲劳、精神错乱、失眠、幻症、耳疾。",
    "核心原点 ④：文明",
    "解释：火带来了熟食和光明，是人类文明的开端，象征着文化、教育、契约等一切智慧的产物。",
    "地理：图书馆、印刷厂、电视台、教堂、学校、文化部门。",
    "人物：文人、作家、影视经营者、博学、编辑、纪检人员、白领人员、幻想者。",
    "静物：报刊、图书、字画、文件、票据、证件、契约、执照、照片、电脑、电视、复印机。"
  ],
  "trigram:乾": [
    "核心原点 ①：最有权",
    "解释：乾为天，为万物之始，是法则的制定者与权力的象征，代表着至高无上的统帅、管理与核心地位。",
    "概念：有威严、权力、统帅、正直、尊敬、创造、法则、本原、核心、精华、向上、长辈、永久。",
    "性情：严正威武、威严豁达、正直勤勉、自尊高傲。",
    "地理：首脑集中地、京都、大城市、大会堂、广场、高级住宅、大厦、警察局、机关、武官、博物馆、邮局。",
    "人物：国家元首、主要领导人、寺院主持、总经理、老板、祖父、老者、厂长、高贵的人、元老。",
    "静物：神佛物品。",
    "人体：头、颈、面部、男性生殖器、精液。",
    "疾病：头痛、脑淤血、心脏病、神经病、老病、旧病、急性暴病。",
    "姓字排行：在兄弟中排行老大、老四、老七。",
    "核心原点 ②：最有钱",
    "解释：乾卦五行属金，方位在西北（金库之地），代表金玉、财富以及秋天的圆满收获。",
    "概念：充实、满足、圆满、收获。",
    "形态：高档贵重、精致完美、白色、金黄色。",
    "地理：西北方、繁华地、银行、金属工厂、配件商店。",
    "时间：秋天、九十月之交、戌、亥年、月、日、时。",
    "静物：金玉珠宝、高档用品、金钱、钟表、镜子、眼镜、圆形金属、首饰。",
    "食物：水果、糖果、蛋糕、年糕、冰激凌、豆腐、鸡蛋、高级食品、火腿、香肠、干肉、马肉、米、麦、豆类、花生。",
    "人体：肺、大肠。",
    "疾病：肺部疾病、结肠疾病，脖子扭伤、皮肤病、骨折、骨病、发肿疾病、伤寒、肋膜炎。",
    "色彩：金黄色、白色。",
    "姓字排行：带金字傍者。",
    "核心原点 ③：最有名",
    "解释：作为权力和成功的极致，乾也代表着由此带来的巨大声望、荣誉和被大众所效仿的典范形象。",
    "概念：模范、喜悦、优胜。",
    "地理：名胜古迹、寺院。",
    "人物：名流、专家。",
    "核心原点 ④：高快",
    "解释：乾的本象为“天”，引申为天空、高处，以及一切具有超越性、高速移动特征的事物。",
    "形态：高大雄伟。",
    "天时：晴天、晴空、太阳。",
    "地理：形胜高亢之所。",
    "动物：龙、鹰。",
    "静物：飞机、火车、轿车、自行车、摩托车、帽子、头巾、面罩、高大物。",
    "核心原点 ⑤：刚健",
    "解释：乾卦三爻皆阳，纯阳至刚，代表着永不停歇的行动力、坚韧不拔的意志和竞争、战争等激烈行为。",
    "概念：健壮、坚固、激烈、战争、竞争、胆量。",
    "性情：好动少静、重情讲义。",
    "形态：坚硬圆滑、趾高气扬。",
    "天时：寒气、霜、雪、冰、雹、霰。",
    "人物：恶人。",
    "动物：狮子、大象、老虎、猪、熊、狗、马、鹅、鲸鱼。",
    "植物：大树、药草。",
    "静物：武器、刀剑。",
    "人体：肋骨、指甲、右腿、皮毛、骨骼。",
    "色彩：大赤色、玄色、强烈的颜色。"
  ],
  "trigram:巽": [
    "核心原点 ①：木",
    "解释：巽卦五行属木，代表一切与木材、植物、生长、绿色相关的象意。",
    "概念：生长、生命力、自然、环保、生发。",
    "形态：青绿色、高直的、细长的、柔韧的。",
    "天时：春季。",
    "地理：森林、花园、植物园、木材厂。",
    "人物：园丁、林业工人、木匠、植物学家、建筑材料商、木材商。",
    "植物：柳、芦苇、竹、松、杉、蔓草类、葡萄百合、牵牛花、葫芦、玫瑰、丝瓜、南瓜。",
    "静物：树木、木制品、纤维品、竹木品、水果、药材。",
    "人体：肝、胆。",
    "疾病：肝脏疾病、胆结石、胆疾。",
    "色彩：青绿、碧绿。",
    "姓字排行：草木傍姓氏，行为四、五、三、八。",
    "核心原点 ②：柔顺",
    "解释：巽为长女，性情柔顺，如微风拂面。同时也代表着灵巧的工艺、文雅以及华而不实的表象。",
    "概念：柔和、顺从、调和、谦逊。",
    "性情：优柔寡断、柔和谦虚、心情徘徊、狡猾市侩、虚情假意、超俗世外、华而不实。",
    "形态：外刚内柔、条形的。",
    "地理：花木茂盛之地、寺观楼台、工艺厂、设计院。",
    "人物：长女、妻子、女友、寡妇、秃头(风有散失之象)、教师、科技人员、狡猾者、优柔寡断者、文质彬彬读书人、能工巧匠、自由职业者。",
    "动物：蛤蟆、壁虎、蜥蜴。",
    "食物：鸡肉、泥鳅、鲤鱼、兽肉、大蒜、有强烈刺激味的食物、蔬菜、长葱、胡萝卜、芹菜、韭菜、百合、山珍、酸性食物、熏制的肉类、纤维质的蔬菜。",
    "静物：扇子、电风扇、鼓风机、通风机器、丝绳、抽屉、屏风、草鞋、椅子、床、毛巾、纸张、铅笔、小刀、化妆用具、拆信、雕刻物。",
    "疾病：脱肛、秃头病、骨折、洁癖。",
    "核心原点 ③：流动——运输、传播",
    "解释：风的本性是流动，无固定形态，代表一切移动、运输、奔波和信息传播相关的象意。",
    "概念：流动、货运、迷途、奔波、号令(随风传播)、荣誉(名声远扬)、普遍性、自由运动、忙碌。",
    "形态：游动传输的、忙碌的、波动的。",
    "天时：风、大风、旋风、龙卷风。",
    "地理：东南方、邮局、过道、长廊、升降机、索道、传送带、码头、商店、各种管道处、电梯、通风道、出入口。",
    "人物：营销员、向导、新闻人员、公关人员、商人、流浪者、作者、广告业、出版业。",
    "动物：鸡(不停走动)、鸭、鹅、蜻蜓、蝙蝠、蜜蜂、蝴蝶、斑马、长颈鹿、蛇、蚯蚓、带鱼、鳗鱼、鳝鱼。",
    "静物：汽艇、帆船、电线杆、铁轨、气球、风筝、各种票据(流通之物)。",
    "人体：股(用于行走)、练功元气(体内流动)。",
    "疾病：病情不稳定、坐骨神经痛、淋巴疾病、抽筋、强直强硬症、左肩痛、胀气。",
    "时间：春夏之交、辰巳年、月、日、时。",
    "核心原点 ④：渗透",
    "解释：风无孔不入，能深入缝隙；其形态无形，可闻可见但不可捉摸，引申为深入、疑惑、空虚和与嗅觉、呼吸相关的意象。",
    "概念：空虚、深入、浅出、疑惑、徘徊、渗透性、没有固定地点。",
    "形态：烟状气态、轻飘轻浮、向下向理发展、上实下虚、神奇的、耳闻鼻嗅的、基础差的、外实内虚。",
    "天时：臭气、下弦月(朦胧之象)。",
    "地理：山林、洞穴、草原、芦苇荡。",
    "人物：僧尼、仙道之人、有狐臭。",
    "静物：香烟、有香味的东西、宣传品、下面有口之物(容器)。",
    "人体：呼吸系统、食道、肠、神经、头发、血管、腹部、腋下、乳、耳。",
    "疾病：伤风感冒、气管阻塞、哮喘、支气管炎、中风、肋骨神经痛、神经痛、内脏疾病、食道疾病、痔疮、狐臭、发恶臭的病、毛发病、动脉硬化、受风、传染病、血管病、忧郁症。"
  ],
  "trigram:震": [
    "核心原点 ①：长男",
    "解释：震在八卦家族中为长男，是家庭和组织中的继承者与开拓者。他代表了果断的行动力、新兴的权威和勤奋开拓的精神。",
    "人物：长男、长子、年长者、名人、医生、学生、电器商、木匠、旅行者、律师、将帅、军人、壮士、警察、法官、社会活动家。",
    "性情：意气风发、积极果断、刚愎自用、勤奋直爽、自尊心强、独断专行。",
    "概念与形态：果断、勇敢的、竞争的。",
    "地理：公安机关、军队、商店、游乐场。",
    "动物：龟、蜈蚣、蜘蛛、蜂类、多足类、鲤鱼 (有跃龙门奋起之象)。",
    "静物：裙、裤子、腰带、绳子、箱子 (行动和束装之物)。",
    "疾病：妇科病、腿痛 (传统归类，关联较弱，可理解为行动过度的损伤)。",
    "姓字排行：带木姓人，行位3、4、8。",
    "核心原点 ②：震动",
    "解释：这是震卦最核心的物理表现。能量的瞬间释放导致了物理层面的剧烈运动、冲击和不稳定状态，从大地的震颤到人心的惊动。",
    "概念：震动、惊动、躁动、冲动、转移、迅速、显现、影响。",
    "天时：大冰雹、闪电、地震、海啸、火山喷发。",
    "地理：战场、运动场、停车厂、骚乱场所。",
    "静物：飞机、汽车、火车 (高速移动的载体)、武器、棒子 (用于冲击)。",
    "人物：驾驶员、运动员、飞行员。",
    "性情：易怒性急、多动少静、心烦意乱、宁死不屈、神经过敏 (内在的震动)。",
    "形态：震动、激烈的、高速的、急躁的、移动的、滑动的、吃惊的。",
    "形态特征：外虚内实、上虚下实、上大下小 (源于震卦“☳”的卦形，上两爻为阴，下爻为阳)。",
    "人体：足 (用于奔走震动)、神经、左肋、左肩臂、左手。",
    "疾病：神经病、足疾、扭伤、脚气、发狂、歇斯底里症、恐惧、精神失常、癫痫症、心悸、关节炎、手足麻痹、神经衰弱、碰撞性外伤。",
    "动物：龙、蛇 (身体震动或蜿蜒而行)。",
    "核心原点 ③：声响",
    "解释：这是震卦的听觉表现。巨大的能量以声音的形式爆发出来，代表了一切洪亮、喧哗、有节奏或刺耳的声音，也引申为语言和音乐的表达。",
    "天时：雷雨、雷鸣。",
    "静物：乐器、电器、铃、电话、鞭炮、闹钟、音响、手机、麦克风、鼓。",
    "地理：闹市、繁华街道、广播电台、电影院、歌舞厅、机场、菜市场、乐器店、夜总会、音乐学院、噪音大的场所。",
    "人物：吵闹者、歌手、音乐家、说大话的人。",
    "概念：喧哗、争论。",
    "动物：鹰、燕、蝉、会鸣叫的昆虫、善鸣之马、鸟类。",
    "人体：喉咙、声带、舌。",
    "疾病：喉咙疾病、气喘。",
    "形态：有声有响的、好看而无内容的 (虚有其表，声大实小)。",
    "核心原点 ④：生长",
    "解释：震为动，五行为木，方位为东，时节为春。雷声之后，万物复苏，代表着破土而出的奋发之势和蓬勃的生命力。",
    "概念：奋起、奋进、上升、积极、旺盛、发育、生长。",
    "天时：东风。",
    "时间：春二月、卯年、月、日、时。",
    "色彩：青绿、碧色。",
    "地理：东方、竹林、树林、草木茂盛的地方、公园。",
    "植物：树木、草、竹、蔬菜、花卉、盆栽。",
    "静物：鲜花、山林野味、筐。",
    "形态：粗糙的 (如树皮)。",
    "人体：发、肝脏。",
    "食物：醋、酸的水果 (木味为酸)、樱桃、柠檬、凤梨、桔子、梅子、海藻类、蔬菜类、筋、蹄 (肝主筋，震属木应肝)。",
    "疾病：肝脏疾病、毛发病。"
  ]
};

export const PAN_STEM_COMBO_LOOKUP = {
  "丙+丙": [
    "联想：窗户明亮、向日葵园地、火警、消防队、化工厂、熊熊烈火、加油站。",
    "外景：电器设备、炉冶，或地势高。",
    "内景：厨房、明亮的窗户等。",
    "联想：窗户明亮、向日葵园地、火警、消防队、化工厂、熊熊烈火、加油站、发烧发炎、血压高、竞争激烈",
    "外景：电器设备、炉冶，或地势高、(光伏发电板、烈日下的广场)",
    "内景：厨房、明亮的窗户等、(大功率电器、明亮的顶灯、发热的电脑主机)"
  ],
  "丙+丁": [
    "联想：偷情；煤气灶；肠炎、牙周炎。",
    "外景：电器设备、炉冶，或地势高等。",
    "内景：灶、灯等明亮发光或发热的物体。",
    "联想：偷情、煤气灶、肠炎、牙周炎、眼疾、电器短路、希望之火被点燃又熄灭",
    "外景：电器设备、炉冶，或地势高等、(高压电线塔、电焊作业现场)",
    "内景：灶、灯等明亮发光或发热的物体、(燃气灶、电子打火机、充电中的手机)"
  ],
  "丙+庚": [
    "联想：国道、公车、执法部门的车、灯塔、电杆、枪战、警匪片、警察抓贼、电线杆。",
    "外景：灯塔、电线杆等。",
    "内景：明亮的窗或门、金属发热体等。",
    "联想：国道、公车、执法部门的车、灯塔、电杆、枪战、警匪片、警察抓贼、电线杆、发炎肿胀需手术、激烈冲突、阻力被化解",
    "外景：灯塔、电线杆等、(检查站、高速公路)",
    "内景：明亮的窗或门、金属发热体等、(防盗门、金属暖气片、明亮的落地窗)"
  ],
  "丙+癸": [
    "联想：红酒、葡萄酒、荷花塘、淫荡、天罗地网、喜酒。",
    "外景：热力管线、荷花塘、热水井等。",
    "内景：红酒、红醋、红色饮料、热水管线等。",
    "联想：红酒、葡萄酒、荷花塘、淫荡、天罗地网、喜酒、眼疾、泌尿系统炎症、见不得光的好事",
    "外景：热力管线、荷花塘、热水井等、(桑拿房、地下温泉)",
    "内景：红酒、红醋、红色饮料、热水管线等、(卫生间里的热水器、暗红色的灯光)"
  ],
  "丙+己": [
    "联想：肠炎、垃圾桶、红砖、圆形的坑、红土地、热气包。",
    "外景：圆形的坑、红色绳状物、红砖堆等。",
    "内景：圆形垃圾桶、堆放杂物等。",
    "联想：肠炎、垃圾桶、红砖、圆形的坑、红土地、热气包、痘痘、想法混乱发热、小投资有回报",
    "外景：圆形的坑、红色绳状物、红砖堆等、(砖窑、垃圾焚烧厂)",
    "内景：圆形垃圾桶、堆放杂物等、(微波炉、电饭煲、堆满杂物的阳台)"
  ],
  "丙+壬": [
    "联想：圆形的水池、血流成河、红河、热水、红鱼、巡警、巡逻艇、水塔。",
    "外景：红色漂浮物、圆形的水池等。",
    "内景：热水器、暖水瓶、圆形容水器等。",
    "联想：圆形的水池、血流成河、红河、热水、红鱼、巡警、巡逻艇、水塔、热水器、水火既济、血压波动",
    "外景：红色漂浮物、圆形的水池等、(温泉、游泳池)",
    "内景：热水器、暖水瓶、圆形容水器等、(鱼缸加热棒、红色水杯、浴室)"
  ],
  "丙+戊": [
    "联想：墙上有红壁灯、红墙、红房子、变压器、路上有交警、窑厂。",
    "外景：窑灶、地势高而开阔，或是红墙，墙边有电器设备等。",
    "内景：灯、炉、电器等。",
    "联想：墙上有红壁灯、红墙、红房子、变压器、路上有交警、窑厂、胃灼热、投资见回报、资金活跃",
    "外景：窑灶、地势高而开阔，或是红墙，墙边有电器设备等、(银行大楼、证券交易所)",
    "内景：灯、炉、电器等、(保险箱旁的灯、墙上的电源插座、发热的地板)"
  ],
  "丙+辛": [
    "联想：红花、红果、花生米、罚款、红豆、第三者出问题。",
    "外景：高出地面的小路、圆形金属物体。",
    "内景：红色的花，或花生米、红豆等物品。",
    "联想：红花、红果、花生米、罚款、红豆、第三者出问题、心肺功能问题、小错误引发大乱子",
    "外景：高出地面的小路、圆形金属物体、(信号塔、红色金属雕塑)",
    "内景：红色的花，或花生米、红豆等物品、(首饰盒、精密仪器、有瑕疵的电器)"
  ],
  "丙+乙": [
    "联想：牵牛花、花开了、红花、妻子有外遇、妻子是警察。",
    "外景：开红花的植物、热力管线、热能器、电灯杆等。",
    "内景：炉灶、窗子、台灯等。",
    "联想：牵牛花、花开了、红花、妻子有外遇、妻子是警察、眼睛发炎、热心助人却遇曲折",
    "外景：开红花的植物、热力管线、热能器、电灯杆等、(阳光下的花园、红色顶棚的建筑)",
    "内景：炉灶、窗子、台灯等、(朝南的窗户、取暖器、红色的装饰品)"
  ],
  "丁+丙": [
    "联想：文章乱了，票据出麻烦了，情人还有他人。",
    "外景：地势高，有电厂、锅炉厂等。",
    "内景：电器设备、圆形灯具等。",
    "联想：文章乱了，票据出麻烦了，情人还有他人、电子产品发热、希望重叠竞争、眼疾加重",
    "外景：地势高，有电厂、锅炉厂等、(通讯基站、信号发射塔)",
    "内景：电器设备、圆形灯具等、(路由器、充电宝、群聊界面)"
  ],
  "丁+丁": [
    "联想：节日灯，组合灯，转盘道，经常做第三者女人。",
    "外景：地势高，有房檐屋角类物、尖状建筑物等。",
    "内景：灯或电器、电子物品等。",
    "联想：节日灯，组合灯，转盘道，经常做第三者女人、手机信号、多个目标、心脏不适",
    "外景：地势高，有房檐屋角类物、尖状建筑物等、(高压线塔群、十字路口)",
    "内景：灯或电器、电子物品等、(多个充电器、成群的小灯、网络节点)"
  ],
  "丁+庚": [
    "联想：十字路口、女人遇到了小偷、房间被隔开了。",
    "外景：路口、铁塔、高楼等。",
    "内景：炉灶、电器等。",
    "联想：十字路口、女人遇到了小偷、房间被隔开了、技术难题、阻碍被突破、手术刀、道路监控",
    "外景：路口、铁塔、高楼等、(红绿灯、交通摄像头)",
    "内景：炉灶、电器等、(防盗报警器、电磁炉、切割机)"
  ],
  "丁+癸": [
    "联想：暖水瓶、洗浴室、水塔；上厕所；近视眼。",
    "外景：废水、污水、脏水。",
    "内景：洗手间、电热设备、电动设备等。",
    "联想：暖水瓶、洗浴室、水塔、上厕所、近视眼、暗昧之事、隐私泄露、泌尿系统感染",
    "外景：废水、污水、脏水、(地下管道、暗沟)",
    "内景：洗手间、电热设备、电动设备等、(马桶、地漏、暗藏的摄像头)"
  ],
  "丁+己": [
    "联想：证件过期了，灯泡坏了，做美容的（己为皮肤），阑尾手术、伤口、不检点的女人。",
    "外景：塑料、玻璃、瓷片等垃圾，凌乱的砖头、瓦片。",
    "内景：有凌乱物品的灯等。",
    "联想：证件过期了，灯泡坏了，做美容的，阑尾手术、伤口、不检点的女人、杂乱的想法阻碍了灵感、皮肤痘痘",
    "外景：塑料、玻璃、瓷片等垃圾，凌乱的砖头、瓦片、(废弃的电子产品、垃圾堆里的灯)",
    "内景：有凌乱物品的灯等、(杂乱数据线、坏掉的U盘、昏暗的储藏室灯)"
  ],
  "丁+壬": [
    "联想：暖水瓶、洗浴室、水塔，门上有灯、情人要走。",
    "外景：河口，或有温泉，或有红色飘动物等。",
    "内景：电动设备、电热设备等。",
    "联想：暖水瓶、洗浴室、水塔，门上有灯、情人要走、合流、智慧之光、远方的消息",
    "外景：河口，或有温泉，或有红色飘动物等、(港口灯塔、河流交汇处)",
    "内景：电动设备、电热设备等、(热水壶、浴室暖风机、智能水表)"
  ],
  "丁+戊": [
    "联想：桌子上有台灯、方形灯箱、裸女，牙龈肿胀。",
    "外景：墙角状物体，墙面反光，路灯、电线杆。",
    "内景：墙上有灯、或图画等物，墙有红色物等。",
    "联想：桌子上有台灯、方形灯箱、裸女，牙龈肿胀、投资科技、平台上的亮点、胃热",
    "外景：砖墙，或有墙角、(墙上的广告灯箱、银行的ATM机)",
    "内景：墙上有灯、或图画等物，墙有红色物等、(壁灯、嵌入式灯带、保险柜上的灯)"
  ],
  "丁+辛": [
    "联想：女人引发问题、女人犯错、爱花钱；手术有问题；眼疾。",
    "外景：岔路，或道路不平。",
    "内景：小型电器、金银首饰用品、手电筒、小型灯具等。",
    "联想：女人引发问题、女人犯错、爱花钱、手术有问题、眼疾、投资错误、精密仪器故障",
    "外景：岔路，或道路不平、(珠宝加工店、金铺)",
    "内景：小型电器、金银首饰用品、手电筒、小型灯具等、(手表、激光笔、微创手术器械)"
  ],
  "丁+乙": [
    "联想：拐弯的丁字路，艺术灯。",
    "外景：开小红花或带刺的植物、小树。",
    "内景：首饰品、电子产品、红色艺术品等。",
    "联想：拐弯的丁字路，艺术灯、针灸、希望之火曲折蔓延、文书电子化",
    "外景：开小红花或带刺的植物、小树、(绿化带里的地灯、弯曲的灯带)",
    "内景：首饰品、电子产品、红色艺术品等、(台灯、电子书、缠绕的电线)"
  ],
  "庚+丙": [
    "联想：锅炉工；开车遇到了红灯；贼来了；车祸；矿难。",
    "外景：锅炉、化工设备等。",
    "内景：明亮的窗子或门。",
    "联想：锅炉工、开车遇到了红灯、贼来了、车祸、矿难、发炎需手术、以硬碰硬、警察行动",
    "外景：锅炉、化工设备等、(检查站、炼油厂)",
    "内景：明亮的窗子或门、(防盗门、警灯、发热的金属器具)"
  ],
  "庚+丁": [
    "联想：监视器；丈夫有情人；丁字路口；有危险了；停电了；电磁炉坏了。",
    "外景：大型的金属电力设备、耀眼的刚性建筑。",
    "内景：窗子上有灯或电子设备等。",
    "联想：监视器、丈夫有情人、丁字路口、有危险了、停电了、电磁炉坏了、技术革新、手术灯",
    "外景：大型的金属电力设备、耀眼的刚性建筑、(红绿灯、雷达站)",
    "内景：窗子上有灯或电子设备等、(门禁系统、电脑主机、丁字尺)"
  ],
  "庚+庚": [
    "联想：两车相撞、车祸、警匪片、两个丈夫、上下铺、骨头断了。",
    "外景：有关卡、收费站的道路，或有两条路等。",
    "内景：门窗、钢性门窗、两个门窗等。",
    "联想：两车相撞、车祸、警匪片、两个丈夫、上下铺、骨头断了、谈判、势均力敌的对抗",
    "外景：有关卡、收费站的道路，或有两条路等、(十字路口、铁路道口)",
    "内景：门窗、钢性门窗、两个门窗等、(对开的门、双扇窗、对峙的格局)"
  ],
  "庚+癸": [
    "联想：车陷到坑里了；酒鬼；上厕所了。",
    "外景：储运罐、水管、车站等。",
    "内景：金属管道、垃圾道。",
    "联想：车陷到坑里了、酒鬼、上厕所了、困难的结束、暗中阻碍、金属腐蚀",
    "外景：储运罐、水管、车站等、(下水道、坑洼的道路)",
    "内景：金属管道、垃圾道、(堵塞的水管、生锈的金属、黑暗的角落)"
  ],
  "庚+己": [
    "联想：水泥路面、路上有垃圾、路上遇到一条狗；床下很乱、环卫车。",
    "外景：废铁堆、废水泥堆、道路不平等。",
    "内景：横梁、门窗旁堆满垃圾等。",
    "联想：水泥路面、路上有垃圾、路上遇到一条狗、床下很乱、环卫车、思路受阻、肮脏的交易",
    "外景：废铁堆、废水泥堆、道路不平等、(垃圾填埋场、施工路段)",
    "内景：横梁、门窗旁堆满垃圾等、(床底下的杂物、堵塞的通道)"
  ],
  "庚+壬": [
    "联想：翻车了、车掉水沟里了、贼跑了、仇人溜了。",
    "外景：车站、港口、马路等。",
    "内景：窗子有窗帘等，有水管等。",
    "联想：翻车了、车掉水沟里了、贼跑了、仇人溜了、变化中的阻碍、远行遇阻、流动性危机",
    "外景：车站、港口、马路等、(渡口、流动的车辆)",
    "内景：窗子有窗帘等，有水管等、(移动的门、下水道、变化的布局)"
  ],
  "庚+戊": [
    "联想：路上有土堆；路断了；面目全非；胃癌。",
    "外景：铁塔、墙角、铁栅栏、水泥墙等。",
    "内景：有横梁。",
    "联想：路上有土堆、路断了、面目全非、胃癌、资金受阻、高大的金属建筑",
    "外景：铁塔、墙角、铁栅栏、水泥墙等、(桥梁、矿山)",
    "内景：有横梁、(承重墙、金属梁、高大的家具)"
  ],
  "庚+辛": [
    "联想：骨裂；拉肚子；车出问题了；床坏了；关节炎。",
    "外景：大路路面不平或坏损，大小两条道路，路边有碎石等。",
    "内景：大小门窗两个。",
    "联想：骨裂、拉肚子、车出问题了、床坏了、关节炎、道路纠纷、错误决策导致阻碍",
    "外景：大路路面不平或坏损，大小两条道路，路边有碎石等、(崎岖的山路、破损的桥梁)",
    "内景：大小门窗两个、(有问题的锁、破损的金属物品)"
  ],
  "庚+乙": [
    "联想：走弯路；曲折的历程；夫妻在一起；金属的艺术品；高明的医生；过硬的绘画艺术。",
    "外景：弯曲的路、钢结构的门窗。",
    "内景：横梁弯曲，窗旁有爬山虎或牵牛花，窗旁放艺术品等。",
    "联想：走弯路、曲折的历程、夫妻在一起、金属的艺术品、高明的医生、过硬的绘画艺术、硬汉有柔情",
    "外景：弯曲的路、钢结构的门窗、(林荫道、金属雕塑)",
    "内景：横梁弯曲，窗旁有爬山虎或牵牛花，窗旁放艺术品等、(有金属框架的屏风、带软垫的硬椅)"
  ],
  "癸+丙": [
    "联想：红眼病、热水器、脚发炎。",
    "外景：圆形水池、池塘等，有热水管线，地下热能或消防系统等。",
    "内景：灭火器、热水器、暖气等。",
    "联想：红眼病、热水器、脚发炎、暗中的热情、见不得光的成功",
    "外景：圆形水池、池塘等，有热水管线，地下热能或消防系统等、(地下温泉、消防栓)",
    "内景：灭火器、热水器、暖气等、(暗红色的灯、浴室加热器)"
  ],
  "癸+丁": [
    "联想：近视眼。",
    "外景：星罗棋布的池塘，或水道纵横，或污水遍布。",
    "内景：下水井、阴沟、厕所等。",
    "联想：近视眼、暗中的亮点、隐私曝光、秘密技术",
    "外景：星罗棋布的池塘，或水道纵横，或污水遍布、(地下光缆、污水井)",
    "内景：下水井、阴沟、厕所等、(暗灯、隐蔽的摄像头、微光)"
  ],
  "癸+庚": [
    "联想：要打架了。窗台上有水珠。",
    "外景：道路有积水、脏物、道路坑洼不平。",
    "内景：门窗肮脏，门窗边有污物等。",
    "联想：要打架了、窗台上有水珠、困难的结束、暗中阻碍、金属生锈",
    "外景：道路有积水、脏物、道路坑洼不平、(坑洼的金属路面)",
    "内景：门窗肮脏，门窗边有污物等、(生锈的水管、堵塞的厕所)"
  ],
  "癸+癸": [
    "联想：大眼睛、阴雨连绵。",
    "外景：河流纵横，或街道车水马龙，或是湿地洼地等。",
    "内景：黑暗潮湿、霉气味，有洗手间、厨房等。",
    "联想：大眼睛、阴雨连绵、重水、极度隐秘、深陷困境",
    "外景：河流纵横，或街道车水马龙，或是湿地洼地等、(沼泽、深井)",
    "内景：黑暗潮湿、霉气味，有洗手间、厨房等、(地下室、牢房、极度阴暗的角落)"
  ],
  "癸+己": [
    "联想：垃圾、发酵了、酒箱子、醋坛子。",
    "外景：垃圾脏水，湿泥坑等。",
    "内景：发酵物品、发霉的物品、厕所、畜物间等。",
    "联想：垃圾、发酵了、酒箱子、醋坛子、阴暗的想法、肮脏的欲望",
    "外景：垃圾脏水，湿泥坑等、(化粪池、污水坑)",
    "内景：发酵物品、发霉的物品、厕所、畜物间等、(下水道、阴暗的储藏室)"
  ],
  "癸+壬": [
    "联想：流窜犯、跑业务的、小雨转大雨。",
    "外景：大小交错的河或湖池，或热闹的街巷。",
    "内景：黑暗潮湿，双层窗帘，有厨房洗手间、线管等。",
    "联想：流窜犯、跑业务的、小雨转大雨、暗流涌动、远行的结束",
    "外景：大小交错的河或湖池，或热闹的街巷、(地下河、暗沟)",
    "内景：黑暗潮湿，双层窗帘，有厨房洗手间、线管等、(地下室、隐秘的通道)"
  ],
  "癸+戊": [
    "联想：子宫增生、做足疗的。",
    "外景：墙边有污水池、污水井等。",
    "内景：汤盆、酒坛、酒瓶、水缸等物器。",
    "联想：子宫增生、做足疗的、暗中的资金、湿土、合污",
    "外景：墙边有污水池、污水井等、(堤坝的阴面、湿墙)",
    "内景：汤盆、酒坛、酒瓶、水缸等物器、(地下仓库、浴室)"
  ],
  "癸+辛": [
    "联想：肾结石、吸毒。",
    "外景：酿造厂、饮料厂、小路上有积水、脏物，道路坑洼不平、砖石砌成的水池。",
    "内景：发酵、变质的液体或饮料、调料瓶。",
    "联想：肾结石、吸毒、错误的信息、液体变质、阴谋",
    "外景：酿造厂、饮料厂、小路上有积水、脏物，道路坑洼不平、砖石砌成的水池、(毒品窝点、酿酒厂)",
    "内景：发酵、变质的液体或饮料、调料瓶、(药瓶、注射器、阴暗的角落)"
  ],
  "癸+乙": [
    "联想：洗头房、洗头、下水道拐弯了。",
    "外景：水塘、水草、低洼地等。",
    "内景：水管线，煤气管线，有淋浴器、水龙头，醋瓶、饮料、调料等。",
    "联想：洗头房、洗头、下水道拐弯了、隐秘的感情、饮料、艺术的阴暗面",
    "外景：水塘、水草、低洼地等、(湿地的植被、沟渠)",
    "内景：水管线，煤气管线，有淋浴器、水龙头，醋瓶、饮料、调料等、(厨房下水道、酒柜)"
  ],
  "己+丙": [
    "联想：设想的计划乱套了；肚里窝火；思想混乱；肠炎；糊涂。",
    "外景：花园、锅炉房、饭店、食品加工厂等。",
    "内景：厨房或阳台。",
    "联想：设想的计划乱套了、肚里窝火、思想混乱、肠炎、糊涂、投资失利、发热的肠胃炎、红色的痘痘或疮",
    "外景：花园、锅炉房、饭店、食品加工厂等、(烧烤摊、化粪池、红色屋顶的矮房)",
    "内景：厨房或阳台、(微波炉、烤箱、堆在阳台的杂物)"
  ],
  "己+丁": [
    "联想：垃圾邮件；变压器；土地官司。",
    "外景：花园、变压器、菜园、公园等。",
    "内景：电器设备、电磁壶、茶壶、尖锐的垃圾等物品。",
    "联想：垃圾邮件、变压器、土地官司、针灸、微创手术、精密仪器的线路板、舌尖上的溃疡、丁字路口的垃圾站",
    "外景：花园、变压器、菜园、公园等、(信号塔、带刺的灌木丛、公共厕所)",
    "内景：电器设备、电磁壶、茶壶、尖锐的垃圾等物品、(充电器、图钉、订书针、插排)"
  ],
  "己+庚": [
    "联想：想阻止而没有阻止；装垃圾的车；有不健康的想法。",
    "外景：弯曲的大路，路边有垃圾堆等。",
    "内景：锅、铲等食品加工用具，或马桶、垃圾桶等。",
    "联想：想阻止而没有阻止、装垃圾的车、有不健康的想法、肠梗阻、道路施工、被金属割伤的皮肤",
    "外景：弯曲的大路，路边有垃圾堆等、(国道旁的垃圾站、铁轨旁的废弃物、拆迁现场)",
    "内景：锅、铲等食品加工用具，或马桶、垃圾桶等、(金属垃圾桶、破损的刀具、手术刀)"
  ],
  "己+癸": [
    "联想：想去厕所；想喝酒；拉肚子。",
    "外景：坑厕、垃圾塘、泥塘等。",
    "内景：泥或陶瓷的酒瓶、油瓶、饮料瓶。",
    "联想：想去厕所、想喝酒、拉肚子、阴沟堵塞、酒驾、隐秘的性欲、糖尿病",
    "外景：坑厕、垃圾塘、泥塘等、(沼泽地、污水井、化工厂的废水池)",
    "内景：泥或陶瓷的酒瓶、油瓶、饮料瓶、(酱油瓶、醋瓶、化妆品、湿漉漉的拖把)"
  ],
  "己+己": [
    "联想：坟头很多；再三考虑；自私吝啬。",
    "外景：坟地、垃圾厂等。",
    "内景：垃圾、塑料瓶等。",
    "联想：坟头很多、再三考虑、自私吝啬、极度纠结、连环陷阱、便秘、肠道息肉",
    "外景：坟地、垃圾厂等、(乱葬岗、垃圾山、错综复杂的田间小路)",
    "内景：垃圾、塑料瓶等、(堆积如山的旧物、狭窄的储藏室、下水道)"
  ],
  "己+壬": [
    "联想：洗澡、上厕所、不想干了、要走了、思想开小差。",
    "外景：一条弯曲的河流、或不规则的湖泊。",
    "内景：有动的物品。",
    "联想：洗澡、上厕所、不想干了、要走了、思想开小差、投资打水漂、泌尿系统问题、肚子里的腹水",
    "外景：一条弯曲的河流、或不规则的湖泊、(下水道出口、污水河、流动的沙丘)",
    "内景：有动的物品、(鱼缸、抽水马桶、饮水机、晃动的水杯)"
  ],
  "己+戊": [
    "联想：肚子大了、怀孕了、大肚和尚；临值符弥勒佛；想钱了；脂肪瘤。",
    "外景：坟地、陵园、垃圾堆等。",
    "内景：墙边有垃圾、杂乱物，墙边有食品等。",
    "联想：肚子大了、怀孕了、大肚和尚、临值符弥勒佛、想钱了、脂肪瘤、房地产策划、胃胀气、城墙边的土堆",
    "外景：坟地、陵园、垃圾堆等、(山脚下的垃圾场、巨大的土堆、银行旁边的废品站)",
    "内景：墙边有垃圾、杂乱物，墙边有食品等、(保险柜、储蓄罐、墙角发霉)"
  ],
  "己+辛": [
    "联想：想法错了；拉肚子、肠炎；皮肤病；羊肠小道；想犯错误。",
    "外景：羊肠小路，路旁有土堆或垃圾堆、菜园、坟地等。",
    "内景：颗粒食品，金属项链和手镯，金属摆件等。",
    "联想：想法错了、拉肚子、肠炎、皮肤病、羊肠小道、想犯错误、金融诈骗、投资失误、皮肤过敏",
    "外景：羊肠小路，路旁有土堆或垃圾堆、菜园、坟地等、(碎石小路、金属废料堆、首饰加工厂附近)",
    "内景：颗粒食品，金属项链和手镯，金属摆件等、(药丸、散落的硬币、金属纽扣、锁)"
  ],
  "己+乙": [
    "联想：犹疑不决、作家、画家、搞艺术的、搞策划的、拉肚子。",
    "外景：田园、菜园、公园等。",
    "内景：绳索、电线乱成一团。",
    "联想：犹疑不决、作家、画家、搞艺术的、搞策划的、拉肚子、肠胃蠕动不畅、合作中的小心思、艺术创作中的线条、藤蔓植物、血管弯曲",
    "外景：田园、菜园、公园等、(绿化带、弯曲的小径、艺术雕塑)",
    "内景：绳索、电线乱成一团、(缠绕的数据线、晾衣绳、窗帘的流苏)"
  ],
  "壬+丙": [
    "联想：太阳能热水器、温泉、温水、水晶球。",
    "外景：圆形的湖泊或水池。",
    "内景：红窗帘，透光的门窗，热水器等。",
    "联想：太阳能热水器、温泉、温水、水晶球、热水泛滥、智慧之光普照",
    "外景：圆形的湖泊或水池、(温泉度假村、太阳能板)",
    "内景：红窗帘，透光的门窗，热水器等、(浴室、暖水瓶、发光的水晶)"
  ],
  "壬+丁": [
    "联想：有私心了、歪主意、非分之想、有猫腻、在外面有情人、走错道了、要做手术了、流产了。",
    "外景：河流交汇或有道路交汇。",
    "内景：连体的门窗，有热水器，交会的水管等。",
    "联想：有私心了、歪主意、非分之想、有猫腻、在外面有情人、走错道了、要做手术了、流产了、合流、智慧与灵感的结合",
    "外景：河流交汇或有道路交汇、(港口、三岔河口)",
    "内景：连体的门窗，有热水器，交会的水管等、(并联的管道、智能家居系统)"
  ],
  "壬+庚": [
    "联想：客车、出租车、抗洪、换丈夫、公平。",
    "外景：河流上有闸口，或河道堵塞，河上有桥梁，或立交桥等。",
    "内景：门窗经常不开或上锁等。",
    "联想：客车、出租车、抗洪、换丈夫、公平、流动的阻碍、大河上有桥",
    "外景：河流上有闸口，或河道堵塞，河上有桥梁，或立交桥等、(渡轮、水闸)",
    "内景：门窗经常不开或上锁等、(流动的障碍、水龙头)"
  ],
  "壬+癸": [
    "联想：游客、饮料厂、洗澡堂。",
    "外景：河流混浊、肮脏。街道凌乱不平。",
    "内景：窗户很脏，不卫生，洗手间、厨房脏乱等。",
    "联想：游客、饮料厂、洗澡堂、阴雨连绵、暗流涌动、隐秘的欲望",
    "外景：河流混浊、肮脏。街道凌乱不平、(污水河、泥泞的道路)",
    "内景：窗户很脏，不卫生，洗手间、厨房脏乱等、(下水道、阴暗的角落、潮湿的房间)"
  ],
  "壬+己": [
    "联想：拥挤的人流、车道、火车的硬座、流水不畅、水路弯弯。",
    "外景：河水流通不畅，街道人流拥挤。",
    "内景：弯曲水管，或有水池。",
    "联想：拥挤的人流、车道、火车的硬座、流水不畅、水路弯弯、混乱的思绪、子宫问题",
    "外景：河水流通不畅，街道人流拥挤、(拥挤的码头、堵塞的河道)",
    "内景：弯曲水管，或有水池、(弯曲的排水管、混乱的浴室)"
  ],
  "壬+壬": [
    "联想：洪水、浴室、大雨磅礴、海浪滔滔。",
    "外景：宽广的河流、湖泊，或宽广的街道，或宽广的广场等。",
    "内景：门窗开阔、浴室厨房大等。",
    "联想：洪水、浴室、大雨磅礴、海浪滔滔、大水泛滥、远行、人潮涌动",
    "外景：宽广的河流、湖泊，或宽广的街道，或宽广的广场等、(大海、广场)",
    "内景：门窗开阔、浴室厨房大等、(游泳池、开阔的大厅)"
  ],
  "壬+戊": [
    "联想：流动商贩、商人、在流动中赚钱、要搬家了、水上建筑。",
    "外景：河堤、水坝、桥梁或道路堵塞等。",
    "内景：水管堵塞、洗澡池。",
    "联想：流动商贩、商人、在流动中赚钱、要搬家了、水上建筑、资金流动、大坝",
    "外景：河堤、水坝、桥梁或道路堵塞等、(水库、桥梁)",
    "内景：水管堵塞、洗澡池、(保险柜、流动的现金、浴室)"
  ],
  "壬+辛": [
    "联想：走错路了、路岔口、项链丢了、河改道了。",
    "外景：河流改道、出岔，道路分成两岔等。",
    "内景：门窗管不严、或门窗出问题等。",
    "联想：走错路了、路岔口、项链丢了、河改道了、错误的流动、白费力气",
    "外景：河流改道、出岔，道路分成两岔等、(改道的河流、岔路口)",
    "内景：门窗管不严、或门窗出问题等、(漏水的水管、错误的方向)"
  ],
  "壬+乙": [
    "联想：拐弯的河流、道路曲折、门变形了、人流很多的街道、长发飘逸。",
    "外景：一条弯曲的河流，或人流很多的街道。",
    "内景：漂亮的窗帘，艺术的大门等。",
    "联想：拐弯的河流、道路曲折、门变形了、人流很多的街道、长发飘逸、怀孕、智慧的延伸",
    "外景：一条弯曲的河流，或人流很多的街道、(商业步行街、蜿蜒的江河)",
    "内景：漂亮的窗帘，艺术的大门等、(波浪形的装饰、鱼缸里的水草)"
  ],
  "戊+丙": [
    "联想：得到钱了；交罚款；变压器；鼻炎。",
    "外景：窑灶炉冶、热力塔等。",
    "内景：保温瓶、微波炉、包糖罐等物。",
    "联想：得到钱了、交罚款、变压器、鼻炎、投资获利、资金活跃、胃热",
    "外景：窑灶炉冶、热力塔等、(银行、炼钢厂)",
    "内景：保温瓶、微波炉、包糖罐等物、(存钱罐、电暖器、红色的地毯)"
  ],
  "戊+丁": [
    "联想：壁灯、鼻炎、花钱找情人、胃开刀、乳腺手术。",
    "外景：砖墙，或有墙角。",
    "内景：桃子、馅饼、包子等物。",
    "联想：壁灯、鼻炎、花钱找情人、胃开刀、乳腺手术、投资科技、稳定的收入来源",
    "外景：砖墙，或有墙角、(墙上的广告灯箱、银行的ATM机)",
    "内景：桃子、馅饼、包子等物、(墙上的插座、保险箱里的珠宝)"
  ],
  "戊+庚": [
    "联想：拉砖的车；钱丢了；交罚款了。",
    "外景：桥梁、水泥路等。",
    "内景：水泥柱、水泥横梁等。",
    "联想：拉砖的车、钱丢了、交罚款了、资金周转困难、道路施工、大的阻碍、胃部手术",
    "外景：桥梁、水泥路等、(收费站、断头路)",
    "内景：水泥柱、水泥横梁等、(厚重的金属门、保险柜的锁)"
  ],
  "戊+癸": [
    "联想：桥梁、金屋藏娇、房子里有卫生间、足疗。",
    "外景：湿土、湿泥、水泥管线等。",
    "内景：洗手间、厨房等。",
    "联想：桥梁、金屋藏娇、房子里有卫生间、足疗、合污、暗中的资金、湿地、胃寒",
    "外景：湿土、湿泥、水泥管线等、(拱桥、湿滑的山路)",
    "内景：洗手间、厨房等、(地下钱庄、浴室、厨房下水道)"
  ],
  "戊+己": [
    "联想：老板的想法、墙边有垃圾。",
    "外景：坟地、陵园、垃圾堆等。",
    "内景：墙边有垃圾、杂乱物，墙边有食品等。",
    "联想：老板的想法、墙边有垃圾、想投资、腹中长物、想法落地、资产重组",
    "外景：坟地、陵园、垃圾堆等、(山脚下的垃圾场、土坡)",
    "内景：墙边有垃圾、杂乱物，墙边有食品等、(储藏室、仓库、堆积的货物)"
  ],
  "戊+壬": [
    "联想：花钱如流水；水库；水缸、桥梁。",
    "外景：蓄水池、堤坝、河堤等。",
    "内景：椰子、西瓜、坛子、水缸等水具。",
    "联想：花钱如流水、水库、水缸、桥梁、资金流动、大水冲了土地庙、胃胀有积水",
    "外景：蓄水池、堤坝、河堤等、(水库大坝、跨河大桥)",
    "内景：椰子、西瓜、坛子、水缸等水具、(鱼缸、流动的现金、浴室)"
  ],
  "戊+戊": [
    "联想：双倍的投资；梯子；傻子；双份收入；背靠背。",
    "外景：坟地、土丘、冈岭等。",
    "内景：墙边有垃圾、杂乱物，墙边有食品等。",
    "联想：双倍的投资、梯子、傻子、双份收入、背靠背、资金积压、胃胀、固执",
    "外景：坟地、土丘、冈岭等、(高山、巨大的土堆)",
    "内景：墙边有垃圾、杂乱物，墙边有食品等、(厚重的墙体、双层的墙壁)"
  ],
  "戊+辛": [
    "联想：电线杆、鼻子有病；要破财了；墙上有裂缝、有沙堆、墙不平、墙角冲射、肉里有碎骨头。",
    "外景：断裂的墙、墙上有裂缝、沙堆、砖堆、石头堆等。",
    "内景：墙面不平，有颗粒或裂缝等，或有苹果、梨子等物。",
    "联想：电线杆、鼻子有病、要破财了、墙上有裂缝、有沙堆、墙不平、墙角冲射、肉里有碎骨头、投资失误、改革资金",
    "外景：断裂的墙、墙上有裂缝、沙堆、砖堆、石头堆等、(施工中的墙壁、破损的堤坝)",
    "内景：墙面不平，有颗粒或裂缝等，或有苹果、梨子等物、(有裂痕的瓷砖、散落的硬币)"
  ],
  "戊+乙": [
    "联想：墙头起伏不平；墙头草；有钱多次花。",
    "外景：弯曲的墙、牛圈、猪圈等。",
    "内景：陶制艺术品等。",
    "联想：墙头起伏不平、墙头草、有钱多次花、合作生财、脾胃调和、稳妥的投资",
    "外景：弯曲的墙、牛圈、猪圈等、(波浪形的围墙、堤坝上的植被)",
    "内景：陶制艺术品等、(墙上的藤蔓装饰、保险柜里的票据)"
  ],
  "辛+丙": [
    "联想：被警察抓了；闯红灯。",
    "外景：饭店、厨房、铁厂、电厂、机械厂、首饰加工厂等。",
    "内景：厨房、电热器等。",
    "联想：被警察抓了、闯红灯、错误被曝光、小问题引发大麻烦、心肺手术",
    "外景：饭店、厨房、铁厂、电厂、机械厂、首饰加工厂等、(烧烤店、五金店)",
    "内景：厨房、电热器等、(烤箱、有问题的电器、手术台)"
  ],
  "辛+丁": [
    "联想：近视眼、肺部手术、食管开刀。",
    "外景：路口。",
    "内景：首饰，电话、电器等。",
    "联想：近视眼、肺部手术、食管开刀、程序错误、精密错误、小伤口感染",
    "外景：路口、(十字路口、精密仪器厂)",
    "内景：首饰，电话、电器等、(手术刀、激光、微电路)"
  ],
  "辛+庚": [
    "联想：路上遇阻；车祸、锁坏了；小路连接大路；路上有障碍物。",
    "外景：两条道路，小路上有障碍物。",
    "内景：门窗，门窗上有锁等。",
    "联想：路上遇阻、车祸、锁坏了、小路连接大路、路上有障碍物、顽固的错误",
    "外景：两条道路，小路上有障碍物、(死胡同、障碍赛)",
    "内景：门窗，门窗上有锁等、(坏掉的锁、障碍物、纠缠的问题)"
  ],
  "辛+癸": [
    "联想：腿脚出问题、沼泽地。",
    "外景：路旁有泥坑或池塘或低洼地等。",
    "内景：水壶、酒瓶、饮料瓶、水瓶、溶水器等。",
    "联想：腿脚出问题、沼泽地、酒水变质、错误的性关系、暗中的错误",
    "外景：路旁有泥坑或池塘或低洼地等、(污水坑、沼泽)",
    "内景：水壶、酒瓶、饮料瓶、水瓶、溶水器等、(漏水的管道、变质的液体、阴暗的角落)"
  ],
  "辛+己": [
    "联想：青春痘、皮肤病、粉刺、皮肤粗糙、错误的想法、坟地、口误。",
    "外景：小路，路旁有垃圾或菜园、土坑等。",
    "内景：窗子和阳台，或窗子旁堆有垃圾等。",
    "联想：青春痘、皮肤病、粉刺、皮肤粗糙、错误的想法、坟地、口误、错误的策划",
    "外景：小路，路旁有垃圾或菜园、土坑等、(肮脏的小巷、垃圾堆)",
    "内景：窗子和阳台，或窗子旁堆有垃圾等、(杂乱的梳妆台、有污渍的首饰)"
  ],
  "辛+壬": [
    "联想：一座小桥、花钱如流水、流动资金、因贪污而入狱、风流成性。",
    "外景：车站、码头等。",
    "内景：钟表、手表等，玩具模型等。",
    "联想：一座小桥、花钱如流水、流动资金、因贪污而入狱、风流成性、错误的想法在流动",
    "外景：车站、码头等、(浮桥、流动的摊贩)",
    "内景：钟表、手表等，玩具模型等、(水龙头、流动的资金、错误的决策)"
  ],
  "辛+戊": [
    "联想：靠足疗挣钱；经济问题；墙坏了；罚款；二手房。",
    "外景：墙上镶有瓷砖，墙不平或有损伤等。",
    "内景：墙上有钉子等。",
    "联想：靠足疗挣钱、经济问题、墙坏了、罚款、二手房、金融错误、土地问题",
    "外景：墙上镶有瓷砖，墙不平或有损伤等、(破损的墙壁、金融大厦)",
    "内景：墙上有钉子等、(墙上的挂钩、储蓄罐里的假币)"
  ],
  "辛+辛": [
    "联想：二进宫、自责、同样的问题一再发生。",
    "外景：一条崎岖的小路。",
    "内景：门窗，或门窗有毛病。",
    "联想：二进宫、自责、同样的问题一再发生、诉讼、重复犯错",
    "外景：一条崎岖的小路、(盘山公路、曲折的小径)",
    "内景：门窗，或门窗有毛病、(层层叠叠的问题、纠缠不清的关系)"
  ],
  "辛+乙": [
    "联想：歪点子；挑老婆的毛病；为女人犯罪。",
    "外景：铁丝网、金属线、结果或开花的小树或植物。",
    "内景：手镯、项链等金属制品和艺术品。",
    "联想：歪点子、挑老婆的毛病、为女人犯罪、艺术品的瑕疵、矫枉过正",
    "外景：铁丝网、金属线、结果或开花的小树或植物、(修剪过的植物、金属雕塑)",
    "内景：手镯、项链等金属制品和艺术品、(精致的金属摆件、有花纹的刀具)"
  ],
  "乙+丙": [
    "联想：",
    "床上铺的是红被单（乙为床，丙主红色）；头发乱了，头发染红了；拐弯的路上有红灯（乙主弯曲）；女警察（丙主权柄，为警察）。",
    "外景：",
    "开红花的植物、化工厂、热能厂等。",
    "内景：",
    "炉灶等发热工具、窗子等。",
    "联想：床上铺的是红被单、头发乱了染红了、拐弯的路上有红灯、女警察、肝火旺、发高烧、文书证件出问题",
    "外景：开红花的植物、化工厂、热能厂等、(桃花林、红叶林、霓虹灯招牌)",
    "内景：炉灶等发热工具、窗子等、(红色的窗帘、发热的电器、明亮的台灯)"
  ],
  "乙+丁": [
    "联想：",
    "抽烟的女人、老婆抽烟、桌子上有烟；发信息、打电话；台灯；修家电；红领巾；文字键盘；女人流产、来例假了。",
    "外景：",
    "玫瑰、月季、小枣树、刺槐等带刺的植物。",
    "内景：",
    "电器、电子产品、电灯等。",
    "联想：抽烟的女人、老婆抽烟、桌子上有烟、发信息、打电话、台灯、修家电、红领巾、文字键盘、女人流产、来例假了、乳腺增生、文章有错别字",
    "外景：玫瑰、月季、小枣树、刺槐等带刺的植物、(带刺的绿化带、信号塔、电子广告牌)",
    "内景：电器、电子产品、电灯等、(充电器、路由器、电子相框、闪烁的指示灯)"
  ],
  "乙+庚": [
    "联想：",
    "夫妻在一起；女人走在路上；床上有床垫；女人在车上、女人开车；弯路上有个收费站。",
    "外景：",
    "弯曲的大路或林荫大道，堆放大型金属器具。",
    "内景：",
    "金属横梁，或金属门窗。",
    "联想：夫妻在一起、女人走在路上、床上有床垫、女人在车上、女人开车、弯路上有个收费站、韧带拉伤、合作有阻力、法律文书",
    "外景：弯曲的大路或林荫大道，堆放大型金属器具、(国道旁的绿化带、金属雕塑公园)",
    "内景：金属横梁，或金属门窗、(带金属框架的床、铝合金门窗、有金属装饰的家具)"
  ],
  "乙+癸": [
    "联想：",
    "撒网捕鱼、下水道、酒鬼、脚扭伤了、青稞酒、菜汤、踩到瓜皮了、鞋柜、手上有痣。",
    "外景：",
    "荷塘、芦苇塘、湿地、菜地等。",
    "内景：",
    "喜水植物盆景、菜盘子、菜汤、酒类、饮料、厕所等。床铺下面潮湿或有下水管道。",
    "联想：撒网捕鱼、下水道、酒鬼、脚扭伤了、青稞酒、菜汤、踩到瓜皮了、鞋柜、手上有痣、内分泌失调、隐秘的感情、酒精肝",
    "外景：荷塘、芦苇塘、湿地、菜地等、(污水排放口、低洼的草丛)",
    "内景：喜水植物盆景、菜盘子、菜汤、酒类、饮料、厕所等、床铺下面潮湿或有下水管道、(厨房水槽、酒柜、湿拖鞋)"
  ],
  "乙+己": [
    "联想：",
    "捡垃圾、做雕塑的、搞策划的、小树要死了、给庄稼施肥。",
    "外景：",
    "杂乱的草或凌乱的垃圾等。",
    "内景：",
    "有盆景花卉或艺术品等，也代表凌乱，有电线绳索物。",
    "联想：捡垃圾、做雕塑的、搞策划的、小树要死了、给庄稼施肥、肠胃不适、合作想法多但杂乱、艺术创作遇到瓶颈",
    "外景：杂乱的草或凌乱的垃圾等、(荒废的田园、凌乱的花圃、堆肥处)",
    "内景：有盆景花卉或艺术品等，也代表凌乱，有电线绳索物、(凌乱的工作台、缠绕的电线、未完成的画作)"
  ],
  "乙+壬": [
    "联想：",
    "游泳、洗澡、女澡堂。临玄武，跟人私奔了。钓鱼、一条弯曲的河流；水稻田。",
    "外景：",
    "弯曲的河流或不规则的湖泊，也代表河边青草。",
    "内景：",
    "水管线、水龙头、鱼缸、浴缸等。床铺下面潮湿或有下水管道。",
    "联想：游泳、洗澡、女澡堂、临玄武跟人私奔了、钓鱼、一条弯曲的河流、水稻田、泌尿系统感染、思绪泛滥、远行",
    "外景：弯曲的河流或不规则的湖泊，也代表河边青草、(湿地公园、水乡古镇的河道)",
    "内景：水管线、水龙头、鱼缸、浴缸等、床铺下面潮湿或有下水管道、(淋浴间、饮水机、加湿器、潮湿的地下室)"
  ],
  "乙+戊": [
    "联想：",
    "挖土；挖掘机；子宫增生；女人是管钱的、女会计；戴手套；该出钱了（用手拿钱）；土炕、火炕；屋顶上有草。",
    "外景：",
    "有绿色植物的庭院，或一道弯曲的墙，墙上有爬山虎等藤类植物。",
    "内景：",
    "墙面上有艺术品。",
    "联想：挖土、挖掘机、子宫增生、女人是管钱的、女会计、戴手套、该出钱了、土炕、火炕、屋顶上有草、投资农业、脾胃不和",
    "外景：有绿色植物的庭院，或一道弯曲的墙，墙上有爬山虎等藤类植物、(山坡上的梯田、堤坝上的植被)",
    "内景：墙面上有艺术品、(墙上的挂画、置物架上的盆景、保险柜旁的植物)"
  ],
  "乙+辛": [
    "联想：",
    "金属床、手破了、肠炎、拉肚子、做手术、剪发了；妻子犯错误、医生出错了、庄稼病了、有果实的树、受伤了。",
    "外景：",
    "弯曲的小路，或草地上有一条小路。",
    "内景：",
    "门窗已经变形，或窗前放有花草，或一张金属床等。",
    "联想：金属床、手破了、肠炎、拉肚子、做手术、剪发了、妻子犯错误、医生出错了、庄稼病了、有果实的树、受伤了、肝胆结石、决策失误",
    "外景：弯曲的小路，或草地上有一条小路、(石子路、金属围栏旁的小径)",
    "内景：门窗已经变形，或窗前放有花草，或一张金属床等、(有划痕的金属家具、窗台上的小盆栽、手术刀)"
  ],
  "乙+乙": [
    "联想：",
    "乙+乙，看成牵手、握手（乙为手）；亲吻（乙为嘴）；头发厚长（乙为发）；两个老婆（乙为妻）；戴着项链、打领带（乙为脖子、乙为弯曲缠绕）。",
    "外景：",
    "草地或绿植。",
    "内景：",
    "花卉、艺术品、绳子等。",
    "其他：",
    "测人，走路不直，是罗圈腿等。",
    "联想：牵手、握手、亲吻、头发厚长、两个老婆、戴着项链、打领带、双份合作、文书重叠、乙肝病毒",
    "外景：草地或绿植、(成片的灌木丛、茂密的竹林、绿化带)",
    "内景：花卉、艺术品、绳子等、(成对的装饰品、缠绕的丝带、双层窗帘)"
  ]
};
